/**
 * English / German UI strings. Add keys as you internationalize screens.
 */
export const STORAGE_KEY = 'adminLocale';

export const translations = {
  en: {
    'app.title': 'Welivin',
    'common.clearFilters': 'Clear Filters',
    'common.clear': 'Clear',
    'common.refresh': 'Refresh',
    'common.add': 'Add',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.deleting': 'Deleting...',
    'common.save': 'Save',
    'common.saving': 'Saving...',
    'common.update': 'Update',
    'common.cancel': 'Cancel',
    'common.all': 'All',
    'common.active': 'Active',
    'common.inactive': 'Inactive',
    'common.actions': 'Actions',
    'common.search': 'Search',
    'common.loading': 'Loading...',
    'nav.userReports': 'Reports',
    'nav.userActivity': 'User Activity',
    'nav.ratingModules': 'Rating Modules Settings',
    'nav.providerApplications': 'Provider Applications',
    'nav.providerNotifications': 'Provider Notifications',
    'nav.referralLinks': 'Referral Links',
    'nav.contactGoogleRating': 'Google Ratings',
    'nav.promotions': 'Promotions',
    'nav.promotionTypes': 'Promotion Types',
    'nav.contacts': 'Contacts',
    'nav.contactInquiries': 'Contact Inquiries',
    'nav.providerClaims': 'Provider Claims',
    'nav.accommodation': 'Accommodation',
    'nav.accommodationFacilities': 'Accommodation Facilities',
    'nav.accommodationTypes': 'Accommodation Types',
    'nav.provider': 'Provider',
    'nav.events': 'Events',
    'nav.eventTypes': 'Event Types',
    'nav.cities': 'Cities',
    'nav.districts': 'Districts',
    'nav.cityRegistration': 'City Registration',
    'nav.users': 'Users',
    'nav.categories': 'Categories',
    'nav.serviceSubCategories': 'Service Sub Categories',
    'nav.customerSupport': 'Customer Support',
    'nav.documentsVerification': 'Documents Verification',

    'dashboard.title': 'Dashboard Overview',
    'dashboard.welcome': 'System metrics, traffic analytics & operational health',
    'dashboard.statUser': 'Users',
    'dashboard.statCity': 'Cities',
    'dashboard.statEvent': 'Events',
    'dashboard.statPromotion': 'Promotions',
    'dashboard.statContact': 'Contacts',
    'dashboard.statAccommodation': 'Accommodations',
    'dashboard.total': 'Total',
    'dashboard.active': 'Active',
    'dashboard.approved': 'Approved',
    'dashboard.rejected': 'Rejected',
    'dashboard.inactive': 'Inactive',
    'dashboard.newThisMonth': 'New This Month',
    'dashboard.newThisPeriod': 'New',
    'dashboard.pending': 'Pending',
    'dashboard.periodDay': 'Day',
    'dashboard.periodMonth': 'Month',
    'dashboard.periodYear': 'Year',
    'dashboard.allMonths': 'All Months',
    'dashboard.selectMonth': 'Select Month',
    'months.january': 'January',
    'months.february': 'February',
    'months.march': 'March',
    'months.april': 'April',
    'months.may': 'May',
    'months.june': 'June',
    'months.july': 'July',
    'months.august': 'August',
    'months.september': 'September',
    'months.october': 'October',
    'months.november': 'November',
    'months.december': 'December',
    'dashboard.activityOverview': 'Platform Activity Trends',
    'dashboard.activityOverviewSubtitle': 'Platform growth and visitor metrics',
    'dashboard.totalUserVisits': 'Total User Visits',
    'dashboard.totalUniqueVisitors': 'Total Unique Visitors',
    'dashboard.activityMetrics': 'Activity Metrics',
    'dashboard.contactVisitors': 'Contact Visitors',
    'dashboard.eventVisitors': 'Event Visitors',
    'dashboard.promotionVisitors': 'Promotion Visitors',
    'dashboard.accommodationVisitors': 'Accommodation Visitors',
    'dashboard.platformUserVisitsTitle': 'Android & iOS User Visits',
    'dashboard.platformUserVisitsSubtitle': 'Platform traffic breakdown by period',
    'dashboard.categoryBreakdown': 'Category Breakdown',
    'dashboard.noCategoryData': 'No category data available',
    'dashboard.totalItems': 'Total Items',
    'dashboard.moduleHealthTitle': 'Module Health & Volume Comparison',
    'dashboard.moduleHealthSubtitle': 'Real-time entity counts & operational status across system modules',
    'dashboard.totalRecords': 'Total Records',
    'dashboard.activeEntities': 'Approved Entities',
    'dashboard.pendingApprovals': 'Pending Approvals',
    'dashboard.totalVolume': 'Total Volume',
    'dashboard.activeRate': 'Active Rate',
    'dashboard.activeLabel': 'active',
    'dashboard.moduleSuffix': 'Module',
    'dashboard.recentActivity': 'Recent Activity',
    'dashboard.recentActivitySubtitle': 'Latest system actions & approvals',
    'dashboard.noRecentActivity': 'No recent activity recorded',
    'dashboard.cityDialogTitle': 'City Statistics Breakdown',
    'dashboard.selectCity': 'Select City',
    'dashboard.periodPrefix': 'Period',
    'dashboard.totalVisits': 'Total Visits',
    'dashboard.pendingAction': 'Pending Action',
    'dashboard.errorLoad': 'Error loading statistics',
    'dashboard.errorLoadData': 'Error loading dashboard data',
    'nav.accommodations': 'Accommodations',

    'contactGoogleRating.title': 'Google Ratings',
    'contactGoogleRating.subtitle': 'Manage Google ratings and reviews for contacts.',
    'contactGoogleRating.addRating': 'Add Google Rating',
    'contactGoogleRating.searchPlaceholder': 'Search by contact name, ID, or review URL...',
    'contactGoogleRating.statusLabel': 'Status',
    'contactGoogleRating.colContact': 'Title',
    'contactGoogleRating.colRating': 'Google Rating',
    'contactGoogleRating.colTotalRatings': 'Total Reviews',
    'contactGoogleRating.colReviewUrl': 'Review URL',
    'contactGoogleRating.colStatus': 'Status',
    'contactGoogleRating.loading': 'Loading Google ratings...',
    'contactGoogleRating.noDataTitle': 'No Google Ratings Found',
    'contactGoogleRating.noDataSubtitle': 'Click "Add Google Rating" to configure a rating for a contact.',
    'contactGoogleRating.dialogAddTitle': 'Add Contact Google Rating',
    'contactGoogleRating.dialogEditTitle': 'Edit Contact Google Rating',
    'contactGoogleRating.fieldContact': 'Select Contact *',
    'contactGoogleRating.fieldRating': 'Google Rating Score (0.0 - 5.0) *',
    'contactGoogleRating.fieldTotalRatings': 'Total Reviews Count *',
    'contactGoogleRating.fieldReviewUrl': 'Google Review URL',
    'contactGoogleRating.fieldIsActive': 'Is Rating Active',
    'contactGoogleRating.confirmDeleteTitle': 'Confirm Delete',
    'contactGoogleRating.confirmDeleteText': 'Are you sure you want to delete the Google rating configuration for',
    'contactGoogleRating.toastCreated': 'Google rating created successfully.',
    'contactGoogleRating.toastUpdated': 'Google rating updated successfully.',
    'contactGoogleRating.toastDeleted': 'Google rating deleted successfully.',
    'contactGoogleRating.toastError': 'Failed to save Google rating.',
    'contactGoogleRating.toastDeleteError': 'Failed to delete Google rating.',
    'contactGoogleRating.toastFetchError': 'Failed to fetch Google ratings data.',
    'contactGoogleRating.errContactRequired': 'Please select a contact.',
    'contactGoogleRating.errRatingInvalid': 'Rating must be between 0 and 5.',
    'contactGoogleRating.errTotalRatingsInvalid': 'Total ratings must be 0 or greater.',
    'contactGoogleRating.errUrlInvalid': 'Please enter a valid URL starting with http:// or https://',

    'referralLink.title': 'Referral Links',
    'referralLink.subtitle': 'Manage affiliate & referral links for Contacts, Events, Promotions, and Accommodations.',
    'referralLink.add': 'Add Referral Link',
    'referralLink.create': 'Create Referral Link',
    'referralLink.edit': 'Edit Referral Link',
    'referralLink.update': 'Update Link',
    'referralLink.delete': 'Delete Referral Link',
    'referralLink.noItems': 'No Referral Links Found',
    'referralLink.moduleKey': 'Module',
    'referralLink.entityId': 'Entity ID',
    'referralLink.selectEntity': 'Select Entity',
    'referralLink.label': 'Link Label',
    'referralLink.summary': 'Summary',
    'referralLink.url': 'Referral URL',
    'referralLink.colTitle': 'Title',
    'referralLink.colLabel': 'Label',
    'referralLink.colSummary': 'Summary',
    'referralLink.colUrl': 'Referral URL',
    'referralLink.colOpenCount': 'Open Count',
    'referralLink.colStatus': 'Status',
    'referralLink.colActions': 'Actions',
    'referralLink.isActive': 'Is Active',
    'referralLink.openCount': 'Open Count',
    'referralLink.createdDT': 'Created Date',
    'referralLink.updatedDT': 'Updated Date',
    'referralLink.toastCreated': 'Referral link created successfully.',
    'referralLink.toastUpdated': 'Referral link updated successfully.',
    'referralLink.toastDeleted': 'Referral link deleted successfully.',
    'referralLink.toastError': 'Failed to save referral link.',
    'referralLink.toastDeleteError': 'Failed to delete referral link.',
    'referralLink.confirmDelete': 'Are you sure you want to delete this referral link?',

    'providerNotifications.title': 'Custom Provider Notifications',
    'providerNotifications.subtitle': 'Review, approve, reject, delete, and send custom provider notification requests.',
    'providerNotifications.searchPh': 'Search title, message, provider name or email...',
    'providerNotifications.filterStatus': 'Filter by Status',
    'providerNotifications.colProvider': 'Provider Info',
    'providerNotifications.colCategory': 'Category',
    'providerNotifications.colTitle': 'Notification Title',
    'providerNotifications.colMessage': 'Message / Content',
    'providerNotifications.colStatus': 'Status',
    'providerNotifications.colDate': 'Created Date',
    'providerNotifications.colActions': 'Actions',
    'providerNotifications.emptyTitle': 'No Provider Notifications Found',
    'providerNotifications.approve': 'Approve',
    'providerNotifications.reject': 'Reject (Note Mandatory)',
    'providerNotifications.createBtn': 'Create Notification',
    'providerNotifications.statusPending': 'Pending',
    'providerNotifications.statusApproved': 'Approved',
    'providerNotifications.statusRejected': 'Rejected',
    'providerNotifications.toastApproved': 'Provider notification approved successfully.',
    'providerNotifications.toastRejected': 'Provider notification rejected successfully.',
    'providerNotifications.toastDeleted': 'Provider notification deleted successfully.',
    'providerNotifications.toastCreated': 'New provider notification created successfully.',
    'providerNotifications.toastStatusUpdated': 'Notification status updated successfully.',
    'providerNotifications.updateStatus': 'Update Status',
    'providerNotifications.errNoteRequired': 'Rejection note is mandatory! Please enter a reason for rejection.',
    'providerNotifications.dialogCreateTitle': 'Create Provider Notification',
    'providerNotifications.fieldCategory': 'Category (Target Type)',
    'providerNotifications.selectCategoryNone': 'None / General',
    'providerNotifications.selectCategoryContact': 'Contact',
    'providerNotifications.selectCategoryPromotion': 'Promotion',
    'providerNotifications.selectCategoryEvent': 'Event',
    'providerNotifications.selectTargetLabel': 'Select',
    'providerNotifications.selectTargetLoading': 'Loading',
    'providerNotifications.selectTargetEmpty': 'No items found',
    'providerNotifications.fieldTitle': 'Notification Title',
    'providerNotifications.fieldTitlePh': 'Enter notification title...',
    'providerNotifications.fieldMessage': 'Notification Message',
    'providerNotifications.fieldMessagePh': 'Enter notification message body...',
    'providerNotifications.btnSendCreate': 'Send / Create',
    'providerNotifications.btnCancel': 'Cancel',
    'providerNotifications.btnClose': 'Close',
    'providerNotifications.viewTitle': 'Notification Details',
    'providerNotifications.viewLoading': 'Loading notification detail...',
    'providerNotifications.viewProviderName': 'Provider Name',
    'providerNotifications.viewProviderEmail': 'Provider Email',
    'providerNotifications.viewTargetCategory': 'Target Category (Type)',
    'providerNotifications.viewServiceTitle': 'Service Title',
    'providerNotifications.viewMessageContent': 'Message Content',
    'providerNotifications.viewNote': 'Approval / Rejection Note',
    'providerNotifications.viewCreatedDate': 'Created Date',
    'providerNotifications.viewSentDate': 'Sent Date',
    'providerNotifications.dialogDeleteTitle': 'Delete Notification',
    'providerNotifications.dialogDeleteMsg': 'Are you sure you want to delete this provider notification record? This action cannot be undone.',
    'providerNotifications.btnDelete': 'Delete',
    'providerNotifications.optionGeneric': 'Generic Notification',
    'providerNotifications.optionCustom': 'Custom Notification',
    'providerNotifications.colSender': 'Sender Info',
    'providerNotifications.colModule': 'Module',
    'providerNotifications.colType': 'Type',
    'providerNotifications.fieldLookbackDays': 'Lookback Days',
    'providerNotifications.fieldLookbackDaysPh': 'e.g. 30',
    'providerNotifications.tabAll': 'All Notifications',
    'providerNotifications.tabGeneric': 'Generic Notifications',
    'providerNotifications.tabCustom': 'Custom Notifications',
    'providerNotifications.genericDesc': 'Broadcast to category audience without specific entity',
    'providerNotifications.customDesc': 'Targeted notification for a specific provider service / entity',
    'providerNotifications.notificationType': 'Notification Type',
    'providerNotifications.filterModule': 'Filter by Module',
    'providerNotifications.filterCategory': 'Filter by Category',
    'providerNotifications.allModules': 'All Modules',
    'providerNotifications.allCategories': 'All Categories',

    'providerApplications.title': 'Provider Applications',
    'providerApplications.subtitle': 'Review and manage provider applications submitted by business owners.',
    'providerApplications.searchPh': 'Search by name, business, category, email, phone...',
    'providerApplications.colAppId': 'ID',
    'providerApplications.colBusinessName': 'Business Name',
    'providerApplications.colApplicant': 'Applicant',
    'providerApplications.colCategory': 'Category',
    'providerApplications.colContact': 'Contact Info',
    'providerApplications.colIntroCall': 'Intro Call',
    'providerApplications.colSubmitted': 'Submitted Date',
    'providerApplications.colActions': 'Actions',
    'providerApplications.emptyTitle': 'No Provider Applications Found',

    'ratingModules.title': 'Rating Modules Settings',
    'ratingModules.subtitle': 'Configure rating, review comments, interval hours, and automated cron triggers for modules.',
    'ratingModules.addModule': 'Add Module',
    'ratingModules.colModuleName': 'Module Name',
    'ratingModules.colModuleKey': 'Module Key',
    'ratingModules.colRatingStatus': 'Rating Status',
    'ratingModules.colCommentsStatus': 'Comments Status',
    'ratingModules.colIntervalHours': 'Interval (Hours)',
    'ratingModules.colCronStatus': 'Cron Status',
    'ratingModules.colLastCronRun': 'Last Cron Run',
    'ratingModules.colActions': 'Actions',
    'ratingModules.ratingEnabled': 'Rating Enabled',
    'ratingModules.commentsEnabled': 'Comments Enabled',
    'ratingModules.cronEnabled': 'Cron Enabled',
    'ratingModules.dialogAddTitle': 'Add New Module',
    'ratingModules.dialogEditTitle': 'Edit Module',
    'ratingModules.fieldDisplayName': 'Display Name',
    'ratingModules.fieldModuleKey': 'Module Key',
    'ratingModules.fieldIntervalHours': 'Interval Hours',
    'ratingModules.fieldSortOrder': 'Sort Order',
    'ratingModules.toastUpdated': 'Rating module settings updated successfully.',
    'ratingModules.toastCreated': 'Rating module created successfully.',
    'ratingModules.toastError': 'Error updating rating module settings.',
    'ratingModules.emptyTitle': 'No Rating Modules Found',
    'ratingModules.emptySubtitle': 'Click "Add Module" to configure your first rating module.',
    'ratingModules.errDisplayNameRequired': 'Please enter a Display Name.',

    'userReports.title': 'Reports',
    'userReports.subtitle': 'Review user and provider submitted reports.',
    'userReports.searchPlaceholder': 'Search title, email, report type...',
    'userReports.searchPlaceholderProvider': 'Search reporter, reported user, email, type...',
    'userReports.filterCategory': 'Report Category',
    'userReports.allCategories': 'All Categories',
    'userReports.filterReportType': 'Report Type',
    'userReports.allTypes': 'All Report Types',
    'userReports.userReports': 'User Report',
    'userReports.providerReports': 'Provider Report',
    'userReports.colReporterName': 'Reporter Name',
    'userReports.colReporterEmail': 'Reporter Email',
    'userReports.colReportedUser': 'Reported User',
    'userReports.colReportType': 'Report Type',
    'userReports.colDescription': 'Description',
    'userReports.colReportTime': 'Report Time',
    'userReports.colStatus': 'Status',
    'userReports.colActions': 'Actions',
    'userReports.colTitle': 'Title',
    'userReports.colEmail': 'Email',
    'userReports.colReportCategory': 'Report Category',
    'userReports.detailUserTitle': 'User Report Details',
    'userReports.detailProviderTitle': 'Provider Report Details',
    'userReports.secReporterDetails': 'REPORTER DETAILS',
    'userReports.secReportedUserDetails': 'REPORTED USER DETAILS',
    'userReports.secReportInfo': 'REPORT INFORMATION',
    'userReports.secDescription': 'DESCRIPTION',
    'userReports.secReportsAgainstUser': 'Reports Against User',
    'userReports.lblReporterName': 'REPORTER NAME',
    'userReports.lblReporterEmail': 'REPORTER EMAIL',
    'userReports.lblReportedUserName': 'REPORTED USER NAME',
    'userReports.lblReportedUserEmail': 'REPORTED USER EMAIL',
    'userReports.lblReportType': 'REPORT TYPE',
    'userReports.lblReportCategory': 'REPORT CATEGORY',
    'userReports.lblReportTime': 'REPORT TIME',
    'userReports.lblUserBlockStatus': 'USER BLOCK STATUS',
    'userReports.lblRelatedContact': 'RELATED CONTACT',
    'userReports.lblTitle': 'TITLE',
    'userReports.statusBlocked': 'Blocked',
    'userReports.statusUnblocked': 'Unblocked',
    'userReports.statusUpdating': 'Updating...',
    'userReports.blockUser': 'Block User',
    'userReports.unblockUser': 'Unblock User',
    'userReports.noDescription': 'No description provided.',
    'userReports.noHistoryFound': 'No previous reports found for this user.',
    'header.notifications': 'Notifications',

    'header.markAllRead': 'Mark all as read',
    'header.viewAllNotifications': 'View All Notifications',
    'notifications.title': 'All Notifications',
    'notifications.filterByCategory': 'Filter by category',
    'notifications.markAllRead': 'Mark all as read',
    'notifications.noNotifications': 'No notifications found.',
    'notifications.status.read': 'Read',
    'notifications.status.unread': 'Unread',
    'notifications.category.all': 'All',
    'notifications.category.accommodation': 'Accommodation',
    'notifications.category.customer_registration': 'Customer registration',
    'notifications.category.documentation': 'Documentation',
    'notifications.category.promotion': 'Promotion',
    'notifications.category.event': 'Events',
    'notifications.category.contact': 'Contact',
    'notifications.category.user': 'User',
    'notifications.category.support': 'Customer Support',
    'header.email': 'Email',
    'header.role': 'Role',
    'header.logout': 'Logout',
    'header.signOut': 'Sign out of your account',
    'header.language': 'Language',
    'header.lang.en': 'English',
    'header.lang.de': 'German',
    'header.changeName': 'Change name',
    'header.changePassword': 'Change password',
    'header.dialogChangeName': 'Update your name',
    'header.dialogChangePassword': 'Update your password',
    'header.currentName': 'Current name',
    'header.newFirstName': 'First name',
    'header.newLastName': 'Last name',
    'header.oldPassword': 'Current password',
    'header.newPassword': 'New password',
    'header.confirmPassword': 'Confirm new password',
    'header.cancel': 'Cancel',
    'header.save': 'Save',
    'header.nameRequired': 'Enter at least a first or last name.',
    'header.fillAllPassword': 'Fill in all password fields.',
    'header.passwordMismatch': 'New password and confirmation do not match.',
    'header.nameUpdated': 'Your name was saved.',
    'header.passwordUpdated': 'Your password was updated.',
    'header.updateFailed': 'Something went wrong. Please try again.',
    'header.missingUserId': 'Your session is missing account details. Please sign in again.',
    'notif.eventRequest': 'New Event Request',
    'notif.eventRequestDesc': 'Summer Music Festival needs approval',
    'notif.registration': 'Registration Approved',
    'notif.registrationDesc': 'New user John Doe was approved',
    'notif.system': 'System Alert',
    'notif.systemDesc': 'High traffic detected on promotion page',
    'notif.failed': 'Failed Operation',
    'notif.failedDesc': 'Contact update failed for ID: 12345',
    'time.minutesAgo': '2 minutes ago',
    'time.hourAgo': '1 hour ago',
    'time.hours3': '3 hours ago',
    'time.hours5': '5 hours ago',
    'nav.dashboard': 'Dashboard',
    'nav.promotions': 'Promotions',
    'nav.contacts': 'Contacts',
    'nav.accommodation': 'Accommodation',
    'nav.accommodationFacilities': 'Accommodation Facilities',
    'nav.accommodationTypes': 'Accommodation Type',
    'nav.events': 'Events',
    'nav.eventTypes': 'Event Type',
    'nav.promotionTypes': 'Promotion Type',
    'nav.serviceSubCategories': 'Service Sub Categories',
    'nav.cities': 'Cities',
    'nav.districts': 'Districts',
    'nav.categories': 'Categories',
    'nav.contactInformation': 'Contact Information',
    'nav.contactInfoDetails': 'Contact Info Details',
    'nav.documentsVerification': 'Documents Verification',
    'nav.users': 'Users',
    'nav.cityRegistration': 'City Registration',
    'nav.customerSupport': 'Customer Support',
    'nav.jobPortals': 'Job Portals',
    'nav.languageSupport': 'Language Support',
    'nav.legalPages': 'Legal Pages',
    'nav.providerClaims': 'Contact Claims',
    'providerClaims.title': 'Contact Claims',
    'providerClaims.searchPh': 'Search claims by name or email...',
    'providerClaims.colContactTitle': 'Contact Title',
    'providerClaims.colFullName': 'Full Name',
    'providerClaims.colRole': 'Role',
    'providerClaims.colBusinessEmail': 'Business Email',
    'providerClaims.colPhoneNumber': 'Phone Number',
    'providerClaims.colProofOfOwnership': 'Proof of Ownership',
    'providerClaims.colDocument': 'Document',
    'providerClaims.colStatus': 'Status',
    'providerClaims.colActions': 'Actions',
    'providerClaims.btnApproveClaim': 'Approve Claim',
    'providerClaims.btnApprove': 'Approve',
    'providerClaims.btnReject': 'Reject',
    'providerClaims.toastApproved': 'Claim approved successfully.',
    'providerClaims.toastRejected': 'Claim rejected successfully.',
    'providerClaims.toastApproveError': 'Error approving claim. Please try again.',
    'providerClaims.empty': 'No Contact claims found.',
    'providerClaims.confirmApprove': 'Are you sure you want to approve this Contact claim?',
    'providerClaims.approveTitle': 'Approve Contact Claim',

    'contactInquiries.title': 'Contact Inquiries',
    'contactInquiries.subtitle': 'Review incoming contact inquiries and dispatch verified or unverified messages to providers',
    'contactInquiries.searchPlaceholder': 'Search by contact, sender, email, message...',
    'contactInquiries.filterCategory': 'Category',
    'contactInquiries.allCategories': 'All Categories',
    'contactInquiries.filterContact': 'Contact',
    'contactInquiries.allContacts': 'All Contacts',
    'contactInquiries.filterReleaseStatus': 'Release Status',
    'contactInquiries.filterContactVerification': 'Contact Verification',
    'contactInquiries.filterContactId': 'Filter by Contact ID',
    'contactInquiries.all': 'All Statuses',
    'contactInquiries.allVerification': 'All Verification',
    'contactInquiries.released': 'Released',
    'contactInquiries.unreleased': 'Pending Release',
    'contactInquiries.verified': 'Verified',
    'contactInquiries.unverified': 'Unverified',
    'contactInquiries.colInquiryId': '# ID',
    'contactInquiries.colContact': 'Recipient Contact',
    'contactInquiries.colSender': 'Sender',
    'contactInquiries.colMessage': 'Message',
    'contactInquiries.colCreatedAt': 'Received Date',
    'contactInquiries.colContactVerified': 'Contact Status',
    'contactInquiries.colReleaseStatus': 'Release Status',
    'contactInquiries.colProgressStatus': 'Progress Status',
    'contactInquiries.colActions': 'Actions',
    'contactInquiries.btnRelease': 'Release',
    'contactInquiries.btnReleasing': 'Releasing...',
    'contactInquiries.btnConfirmRelease': 'Confirm & Dispatch Email',
    'contactInquiries.btnViewDetails': 'View Details',
    'contactInquiries.btnReleaseTooltip': 'Release inquiry and dispatch email to contact',
    'contactInquiries.releaseDialogTitle': 'Release Contact Inquiry',
    'contactInquiries.releaseDialogNotice': 'Releasing this inquiry will immediately dispatch the inquiry email to the contact with the sender message.',
    'contactInquiries.releaseSuccess': 'Contact inquiry #{id} has been released and dispatched successfully!',
    'contactInquiries.loadFailed': 'Failed to load contact inquiries.',
    'contactInquiries.noInquiriesFound': 'No contact inquiries found matching your filters.',
    'contactInquiries.detailsTitle': 'Inquiry Details',
    'contactInquiries.contactDetails': 'Recipient Contact Information',
    'contactInquiries.senderDetails': 'Sender Information',
    'contactInquiries.inquiryContent': 'Inquiry Content',
    'contactInquiries.releaseInfo': 'Release Audit Log',
    'contactInquiries.statTotal': 'Total Inquiries',
    'contactInquiries.statReleased': 'Released',
    'contactInquiries.statPending': 'Pending Release',
    'contactInquiries.statUnverified': 'Unverified Contacts',

    'auth.title': 'Admin Login',
    'auth.email': 'Email Address',
    'auth.password': 'Password',
    'auth.signIn': 'Sign In',
    'auth.forgotPassword': 'Forgot password?',
    'auth.forgotDialogTitle': 'Reset password',
    'auth.forgotStepEmail': 'Enter your account email. We will send a one-time code to that address.',
    'auth.forgotStepReset': 'Enter the code from your email and choose a new password.',
    'auth.sendOtp': 'Send code',
    'auth.otpSent': 'If an account exists for this email, a code has been sent. Check your inbox.',
    'auth.otp': 'One-time code',
    'auth.newPassword': 'New password',
    'auth.confirmNewPassword': 'Confirm new password',
    'auth.resetPassword': 'Reset password',
    'auth.backToEmailStep': 'Use a different email',
    'auth.passwordMismatch': 'New password and confirmation do not match.',
    'auth.resetSuccess': 'Your password was reset. You can sign in now.',
    'auth.resetFailed': 'Could not reset password. Please try again.',
    'auth.invalidEmail': 'Please enter a valid email address.',
    'auth.loginFailed': 'Login failed',
    'auth.loginFailedRetry': 'Login failed. Please try again.',
    'auth.captchaLabel': 'Security Verification',
    'auth.enterCaptcha': 'Security Code',
    'auth.refreshCaptcha': 'Refresh Captcha',
    'auth.captchaRequired': 'Please enter the security code.',
    'auth.captchaInvalid': 'Invalid security code. Please try again.',
    'common.adminUser': 'Admin User',
    'dashboard.title': 'Dashboard',
    'dashboard.welcome': "Welcome back! Here's an overview of your admin panel",
    'dashboard.downloadReport': 'Download Report',
    'dashboard.statUser': 'User Statistics',
    'dashboard.statCity': 'City Statistics',
    'dashboard.statEvent': 'Event Statistics',
    'dashboard.statPromotion': 'Promotion Statistics',
    'dashboard.statContact': 'Contact Statistics',
    'dashboard.statAccommodation': 'Accommodation Statistics',
    'dashboard.total': 'Total',
    'dashboard.active': 'Active',
    'dashboard.newThisMonth': 'New This Month',
    'dashboard.pending': 'Pending',
    'dashboard.monthlyChange': 'Monthly Change',
    'dashboard.current': 'Current',
    'dashboard.last': 'Last',
    'dashboard.recentActivity': 'Recent Activity',
    'dashboard.noRecentActivity': 'No recent activity available.',
    'dashboard.categoryBreakdown': 'Category Breakdown',
    'dashboard.noData': 'No data available.',
    'dashboard.activityOverview': 'Activity Overview',
    'dashboard.viewTimeline': 'View Timeline',
    'dashboard.newUsers': 'New Users',
    'dashboard.activeEvents': 'Active Events',
    'dashboard.recentApprovals': 'Recent Approvals',
    'dashboard.pendingApproval': 'pending approval',
    'dashboard.msgEventsPending': 'Events',
    'dashboard.msgPromotionsPending': 'Promotions',
    'dashboard.msgContactsPending': 'Contacts',
    'dashboard.msgAccommodationsPending': 'Accommodations',
    'dashboard.quickActions': 'Quick Actions',
    'dashboard.quickActionsSub': 'Common tasks',
    'dashboard.activeUsers': 'Active Users',
    'dashboard.activeUsersSub': 'Currently online users',
    'dashboard.moreOnline': 'more',
    'dashboard.currentUsers': 'Current Users',
    'dashboard.approvalStats': 'Approval Statistics',
    'dashboard.approvalStatsSub': 'Last 30 days',
    'dashboard.approved': 'Approved',
    'dashboard.rejected': 'Rejected',
    'dashboard.cityDialogTitle': 'City Statistics',
    'dashboard.selectCity': 'Select City',
    'dashboard.errorLoad': 'Failed to load dashboard statistics',
    'dashboard.errorLoadData': 'Error loading dashboard data. Please try again later.',
    'dashboard.androidAppTracking': 'Android User Tracking',
    'dashboard.iosAppTracking': 'iOS User Tracking',
    'dashboard.totalAppDownloads': 'Total App Downloads',
    'dashboard.googlePlayStore': 'Google Play Store',
    'dashboard.appleAppStore': 'Apple App Store',
    'dashboard.combinedEcosystem': 'Combined Mobile Ecosystem',
    'dashboard.activeAppUsers': 'Active Users',
    'common.city': 'City',
    'common.name': 'Name',
    'common.title': 'Title',
    'common.description': 'Description',
    'common.date': 'Date',
    'common.status': 'Status',
    'common.actions': 'Actions',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.superAdminOnly': 'Only Super Admins can perform this action.',
    'common.cancel': 'Cancel',
    'common.view': 'View',
    'common.mobileView': 'Mobile View',
    'common.close': 'Close',
    'common.update': 'Update',
    'common.create': 'Create',
    'common.add': 'Add',
    'common.search': 'Search',
    'common.all': 'All',
    'common.pleaseWait': 'Please wait...',
    'common.previous': 'Previous',
    'common.next': 'Next',
    'common.optional': 'optional',
    'common.active': 'Active',
    'common.inactive': 'Inactive',
    'common.unknown': 'Unknown',
    'common.approval': 'Approval',
    'common.saving': 'Saving...',
    'common.updating': 'Updating...',
    'common.rowsPerPage': 'Rows per page:',
    'common.note': 'Note',
    'common.approve': 'Approve',
    'common.decline': 'Decline',
    'common.reject': 'Reject',
    'common.moveToPending': 'Move to Pending',
    'common.yes': 'Yes',
    'common.no': 'No',
    'about': 'About',
    'common.openingHours': 'Opening Hours',
    'common.email': 'Email',
    'common.phone': 'Phone',
    'common.website': 'Website',
    'common.address': 'Address',
    'common.houseNumber': 'House Number',
    'common.postalCode': 'Postal Code',
    'common.longitude': 'Longitude',
    'common.latitude': 'Latitude',
    'common.whatsapp': 'WhatsApp',
    'common.whatsAppText': 'WhatsApp Text',
    'common.supportLanguages': 'Support Languages ',
    'common.clientTypes': 'Client Types ',
    'common.imageUrlsComma': 'Image URLs ',
    'common.district': 'District',
    'common.contactClaimed': 'Contact Claimed',
    'common.googleRating': 'Google Rating Available',
    'common.infoNote': 'Info Note',
    'common.contactPerson': 'Contact Person',
    'promotions.title': 'Promotions',
    'promotions.filterCity': 'City',
    'promotions.filterStatus': 'Status',
    'promotions.allStatusesHint': 'All statuses',
    'promotions.errFieldRequired': 'This field is required.',
    'promotions.errTimeRequiredShort': 'Promotion time is required.',
    'promotions.errInvalidDate': 'Enter a valid date (YYYY-MM-DD).',
    'promotions.errInvalidTime': 'Enter a valid time.',
    'promotions.fieldBanner': 'Banner image',
    'promotions.colImage': 'Image',
    'promotions.searchTitle': 'Search by title',
    'promotions.add': 'Add Promotion',
    'promotions.colCity': 'City',
    'promotions.colTitle': 'Title',
    'promotions.colDescription': 'Description',
    'promotions.colDate': 'Date',
    'promotions.colStatus': 'Status',
    'promotions.colApproval': 'Approval',
    'promotions.colActions': 'Actions',
    'promotions.notePrefix': 'Note',
    'promotions.dialogEdit': 'Edit Promotion',
    'promotions.dialogAdd': 'Add New Promotion',
    'promotions.dialogView': 'View Promotion Details',
    'promotions.fieldTitle': 'Promotion Title',
    'promotions.fieldDesc': 'Description',
    'promotions.fieldImageUrls': 'Image URLs ',
    'promotions.fieldDiscountText': 'Discount Text',
    'promotions.fieldDiscountCoupon': 'Discount Coupon',
    'promotions.fieldDate': 'Promotion Date (YYYY-MM-DD)',
    'promotions.fieldTime': 'Promotion Time (HH:mm)',
    'promotions.fieldWebUrl': 'Web URL',
    'promotions.fieldWebUrlBtn': 'Web URL Button Title',
    'promotions.fieldCallToAction': 'Call to Action',
    'promotions.fieldSharingUrl': 'Sharing URL',
    'promotions.fieldTermsAndConditions': 'Terms And Conditions',
    'promotions.fieldTargetedAudience': 'Targeted Audience',
    'promotions.targetAudienceAllUsers': 'All users',
    'promotions.targetAudienceStudents': 'Students',
    'promotions.targetAudienceFamilies': 'Families',
    'promotions.targetAudienceWorkers': 'Workers',
    'promotions.fieldWhatYouGet': 'What You Get',
    'promotions.fieldPromotionDetails': 'Promotion Details',
    'promotions.fieldActive': 'Active',
    'promotions.fieldApprovalStatus': 'Approval Status',
    'promotions.fieldApprovalNote': 'Approval Note',
    'promotions.fieldRecurrence': 'Recurrence',
    'promotions.fieldContactPerson': 'Contact Person',
    'promotions.fieldPersonRole': 'Person Role',
    'promotions.fieldContactPersonGender': 'Contact Person Gender',
    'promotions.approvalDialogTitle': 'Update Promotion Status',
    'promotions.declineNote': 'Decline Note*',
    'promotions.approvalNoteLabel': 'Approval Note',
    'promotions.declineNoteRequired': 'Decline note is required',
    'promotions.placeholderDecline': 'Enter reason for declining...',
    'promotions.placeholderOptional': 'Optional note...',
    'promotions.updateStatus': 'Update Status',
    'promotions.toastFillRequired': 'Please fill in all required fields',
    'promotions.toastValidDate': 'Please enter valid date (YYYY-MM-DD) and time (HH:mm)',
    'promotions.toastUpdated': 'Promotion updated successfully.',
    'promotions.toastAdded': 'Promotion added successfully.',
    'promotions.toastSaveError': 'Error saving promotion. Please try again.',
    'promotions.confirmDelete': 'Are you sure you want to delete this promotion?',
    'promotions.toastDeleted': 'Promotion deleted successfully.',
    'promotions.toastDeleteError': 'Error deleting promotion. Please try again.',
    'promotions.toastNoteReject': 'Approval note is required when rejecting a promotion',
    'promotions.toastApprovalUpdated': 'Promotion status updated successfully.',
    'promotions.toastApprovalError': 'Error updating approval status',
    'contacts.title': 'Contacts Management',
    'contacts.filterCity': 'Filter by City',
    'contacts.filterCategory': 'Filter by Category',
    'contacts.allCategories': 'All Categories',
    'contacts.refresh': 'Refresh',
    'contacts.add': 'Add Contact',
    'contacts.clearFilters': 'Clear Filters',
    'contacts.colInfo': 'Info',
    'contacts.colLocation': 'Location',
    'contacts.colContactDetails': 'Contact Details',
    'contacts.colOwnerName': 'Owner Name',
    'contacts.colAddedByType': 'Added By',
    'contacts.colApprovedByName': 'Approved By',
    'contacts.colBusinessInfo': 'Business Info',
    'contacts.dialogEdit': 'Edit Contact',
    'contacts.dialogAdd': 'Add New Contact',
    'contacts.dialogView': 'View Contact Details',
    'contacts.fieldName': 'Name',
    'contacts.fieldCategory': 'Category',
    'contacts.fieldInfoNote': 'Info Note',
    'contacts.fieldContactPerson': 'Contact Person',
    'contacts.fieldDistrict': 'District',
    'contacts.toastNoteReject': 'Approval note is required when rejecting a contact',
    'contacts.toastUpdated': 'Contact updated successfully.',
    'contacts.toastCreated': 'Contact created successfully.',
    'contacts.toastSaveError': 'Error saving contact',
    'contacts.confirmDelete': 'Are you sure you want to delete this contact?',
    'contacts.toastDeleted': 'Contact deleted successfully.',
    'contacts.toastDeleteError': 'Error deleting contact. Please try again.',
    'contacts.toastFillRequired': 'Please fill in all required fields',
    'contacts.errFieldRequired': 'This field is required.',
    'contacts.errInfoNoteRequired': 'Info note is required.',
    'contacts.errPostalRequired': 'Postal code is required.',
    'contacts.errEmailRequired': 'Email is required.',
    'contacts.errEmailInvalid': 'Enter a valid email address.',
    'contacts.errSubCategoryRequired': 'Select at least one subcategory.',
    'contacts.errPostalDigits5': 'Postal code must be exactly 5 digits.',
    'contacts.errWhatsappMax20': 'WhatsApp number cannot exceed 20 characters.',
    'contacts.helperWhatsappMax20': 'Maximum 20 characters.',
    'contacts.placeholderPostal5': '5 digits',
    'contacts.approvalDialogTitle': 'Update Contact Status',
    'contacts.fieldRejectionNoteShort': 'Rejection Note*',
    'contacts.fieldApprovalNoteShort': 'Approval Note',
    'contacts.helperRejectionRequired': 'Rejection note is required',
    'contacts.toastApprovalErr': 'Error updating approval status',
    'contacts.toastApprovalErr2': 'Failed to update contact approval status',
    'contacts.fieldOwnerName': 'Owner Name',
    'contacts.fieldApprovedBy': 'Approved By',
    'contacts.fieldSubCategories': 'Sub Categories',
    'contacts.fieldSubCategoriesComma': 'Sub Categories ',
    'contacts.documentsRequired': 'Documents Required',
    'contacts.rulesRegulations': 'Terms & Conditions',
    'contacts.pricingInformation': 'Pricing Information',
    'contacts.addPricingPlan': 'Add Pricing Plan',
    'contacts.noPricingPlans': 'No pricing plans added yet',
    'contacts.pricingDescription': 'Add and manage pricing packages, subscription tiers, or fees with highlights and badges.',
    'contacts.planTitle': 'Plan Title',
    'contacts.badgeTag': 'Badge / Tag',
    'contacts.noBadge': 'No badge',
    'contacts.price': 'Price',
    'contacts.billingPeriod': 'Billing Period',
    'contacts.periodMonth': 'Month',
    'contacts.periodWeek': 'Week',
    'contacts.periodYear': 'Year',
    'contacts.periodOneTime': 'One-time',
    'contacts.hintNote': 'Hint / Note',
    'contacts.description': 'Description',
    'contacts.planHighlights': 'Plan Highlights & Features',
    'contacts.highlightPlaceholder': 'Add a highlight and press Enter',
    'contacts.addHighlight': 'Add',
    'contacts.pricingTitleRequired': 'Plan title is required',
    'contacts.pricingDescriptionRequired': 'Plan description is required',
    'contacts.pricingPriceInvalid': 'Enter a valid price with up to 6 digits and up to 2 decimal places',
    'contacts.pricingTitleMax': 'Plan title must be 50 characters or fewer',
    'contacts.pricingDescriptionMax': 'Description must be 500 characters or fewer',
    'contacts.pricingHintMax': 'Hint / Note must be 250 characters or fewer',
    'contacts.pricingFeatureMax': 'Each feature must be 250 characters or fewer',
    'contacts.pricingHeaderTitle': 'Pricing Title',
    'contacts.pricingHeaderDescription': 'Pricing Description',
    'contacts.pricingHeaderTitleMax': 'Pricing header title must be 50 characters or fewer',
    'contacts.pricingHeaderDescriptionMax': 'Pricing header description must be 150 characters or fewer',
    'contacts.pricingPlan': 'Plan',
    'contacts.addItem': 'Add Item',
    'contacts.noItemsAdded': 'No items added yet. Click "Add Item" to add.',
    'contacts.charLimitExceeded': 'Character limit exceeded:',
    'accommodation.title': 'Accommodation',
    'accommodation.add': 'Add Accommodation',
    'accommodation.selectCity': 'Select City',
    'accommodation.searchPlaceholder': 'Search accommodations...',
    'accommodation.colLocation': 'Location Details',
    'accommodation.colContact': 'Contact Info',
    'accommodation.colFinancial': 'Financial Details',
    'accommodation.colAvailability': 'Availability',
    'accommodation.colFacilities': 'Facilities',
    'accommodation.dialogEdit': 'Edit Accommodation',
    'accommodation.dialogAdd': 'Add New Accommodation',
    'accommodation.dialogView': 'View Accommodation Details',
    'accommodation.fieldWhatsApp': 'WhatsApp Number',
    'accommodation.fieldRent': 'Rent',
    'accommodation.fieldDeposit': 'Deposit',
    'accommodation.fieldAvailableFrom': 'Available From',
    'accommodation.fieldOwner': 'Owner Name',
    'accommodation.fieldFacilities': 'Facilities',
    'accommodation.fieldWhatYouGet': 'What You Get',
    'accommodation.fieldImageUrls': 'Image URLs',
    'accommodation.fieldApprovalNote': 'Approval Note',
    'accommodation.fieldEnabled': 'Enabled',
    'accommodation.approveTitle': 'Approve',
    'accommodation.rejectTitle': 'Reject',
    'accommodation.resetTitle': 'Reset',
    'accommodation.approveAccommodation': 'Accommodation',
    'accommodation.fieldRejectionNote': 'Rejection Note*',
    'accommodation.helperRejectNote': 'Note is required when rejecting',
    'accommodation.placeholderReject': 'Enter reason for rejecting...',
    'accommodation.placeholderOptional': 'Optional note...',
    'accommodation.confirmDelete': 'Are you sure you want to delete this accommodation?',
    'accommodation.toastDeleted': 'Accommodation deleted successfully.',
    'accommodation.toastFillRequired': 'Please fill in all required fields.',
    'accommodation.toastFixFieldErrors': 'Please correct the invalid fields before saving.',
    'accommodation.toastUpdateError': 'Error updating accommodation. Please try again.',
    'accommodation.toastDeleteError': 'Error deleting accommodation. Please try again.',
    'accommodation.toastEmail': 'Please enter a valid email address',
    'accommodation.toastRent': 'Please enter a valid rent amount (must be >= 0)',
    'accommodation.toastDeposit': 'Please enter a valid deposit amount (must be >= 0)',
    'accommodation.toastPostalLen': 'Postal code must be between 3 and 10 characters',
    'accommodation.toastPostalNum': 'Postal code can only contain numbers',
    'accommodation.toastLatRequired': 'Latitude is required',
    'accommodation.toastLatRange': 'Please enter a valid latitude between -90 and 90',
    'accommodation.toastLngRequired': 'Longitude is required',
    'accommodation.toastLngRange': 'Please enter a valid longitude between -180 and 180',
    'accommodation.toastUpdated': 'Accommodation updated successfully.',
    'accommodation.toastCreated': 'Accommodation created successfully.',
    'accommodation.toastSaveError': 'Error saving accommodation',
    'accommodation.toastApprovalOk': 'Accommodation status updated successfully.',
    'accommodation.autoFillTitle': 'Auto-Fill from Text',
    'accommodation.autoFillSubtitle': 'Paste listing text & click Auto Fill',
    'accommodation.autoFillPlaceholder': 'Paste raw accommodation text (e.g. Title, Rent €500, Deposit €1000, Address, City, Phone, Email, Facilities)...',
    'accommodation.btnAutoFill': 'Auto Fill from Text',
    'accommodation.toastAutoFillOk': 'Accommodation details auto-filled successfully!',
    'accommodation.toastAutoFillNoMatch': 'No matching accommodation details found in text.',
    'accommodation.isActiveLabel': 'Is Active',
    'accommodation.isEnabledLabel': 'Is Enabled',
    'accommodation.ownerPrefix': 'Owner',
    'accommodation.depositLabel': 'Deposit',
    'accommodation.toastApprovalErr': 'Error updating approval status',
    'facilities.title': 'Accommodation Facilities',
    'facilities.add': 'Add Facility',
    'facilities.searchPlaceholder': 'Search facilities...',
    'facilities.colEnglish': 'English Title',
    'facilities.colGerman': 'German Title',
    'facilities.empty': 'No facilities found.',
    'facilities.dialogEdit': 'Edit Facility',
    'facilities.dialogAdd': 'Add New Facility',
    'facilities.fieldTitleEn': 'Title (English)',
    'facilities.fieldTitleDe': 'Title (German)',
    'facilities.toastFill': 'Please fill in all required fields',
    'facilities.toastUpdated': 'Facility updated successfully.',
    'facilities.toastCreated': 'Facility created successfully.',
    'facilities.toastSaveError': 'Error saving facility. Please try again.',
    'facilities.confirmDelete': 'Are you sure you want to delete this facility?',
    'facilities.toastDeleted': 'Facility deleted successfully.',
    'facilities.toastDeleteError': 'Error deleting facility. Please try again.',
    'accTypes.title': 'Accommodation Type',
    'accTypes.add': 'Add Accommodation Type',
    'accTypes.colId': 'ID',
    'accTypes.colName': 'Name',
    'accTypes.colTranslations': 'Translations',
    'accTypes.empty': 'No accommodation types found.',
    'accTypes.dialogEdit': 'Edit Accommodation Type',
    'accTypes.dialogAdd': 'Add Accommodation Type',
    'accTypes.fieldNamePh': 'e.g. Apartment',
    'accTypes.translationsHint': 'Translations (all fields required)',
    'accTypes.fieldLanguage': 'Language',
    'accTypes.namePlaceholder': 'Translated name',
    'accTypes.addTranslation': 'Add translation',
    'accTypes.toastNameRequired': 'Name is required.',
    'accTypes.toastLangRequired': 'Language code is required.',
    'accTypes.toastTransNameRequired': 'Name is required.',
    'accTypes.translationPrefix': 'Translation ',
    'accTypes.translationLangRequired': 'Translation {n}: Language code is required.',
    'accTypes.translationNameRequired': 'Translation {n}: Name is required.',
    'accTypes.updated': 'Accommodation type updated successfully.',
    'accTypes.created': 'Accommodation type created successfully.',
    'accTypes.saveError': 'Error saving. Please try again.',
    'accTypes.confirmDelete': 'Are you sure you want to delete this accommodation type?',
    'accTypes.deleted': 'Accommodation type deleted successfully.',
    'accTypes.deleteError': 'Error deleting. Please try again.',
    'common.clear': 'Clear',
    'common.enabled': 'Enabled',
    'common.none': 'None',
    'common.free': 'Free',
    'common.save': 'Save',
    'common.preview': 'Preview',
    'common.urlInvalid': 'Please enter a valid URL (e.g., https://example.com)',
    'common.filterClear': 'Clear Filters',
    'common.searchByName': 'Search by Name',
    'common.searchByCode': 'Search by Code',
    'common.isEnabled': 'Is Enabled',
    'common.id': 'ID',
    'common.translations': 'Translations',
    'common.language': 'Language',
    'common.translationsRequired': 'Translations (all fields required)',
    'common.translatedNamePh': 'Translated name',
    'common.addTranslation': 'Add translation',
    'common.visitWebsite': 'Visit Website',
    'common.sharePrefix': 'Share:',
    'events.searchTitle': 'Search by title',
    'events.title': 'Events',
    'events.dialogEdit': 'Edit Event',
    'events.dialogAdd': 'Add New Event',
    'events.dialogView': 'View Event Details',
    'events.addEvent': 'Add Event',
    'events.colDescription': 'Description',
    'events.colLocation': 'Location',
    'events.colDateTime': 'Date & Time',
    'events.colCharges': 'Charges',
    'events.colUrls': 'URLs',
    'events.fieldEventTitle': 'Event Title',
    'events.fieldCharges': 'Charges',
    'events.fieldEventDate': 'Event Date',
    'events.fieldEventTime': 'Event Time',
    'events.fieldWebUrlBtn': 'Web URL Button Title',
    'events.fieldRecurrence': 'Recurrence',
    'events.fieldContactPerson': 'Contact Person',
    'events.fieldPersonRole': 'Person Role',
    'events.fieldContactPersonGender': 'Contact Person Gender',
    'events.approvalDialogTitle': 'Update Event Status',
    'events.toastDeclineNote': 'Approval note is required when declining an event',
    'events.toastStatusOk': 'Event status updated successfully.',
    'events.toastApprovalErrPrefix': 'Error updating approval status',
    'events.errLatRequired': 'Latitude is required',
    'events.errLatNum': 'Latitude must be a valid number',
    'events.errLatRange': 'Latitude must be between -90 and 90',
    'events.errLngRequired': 'Longitude is required',
    'events.errLngNum': 'Longitude must be a valid number',
    'events.errLngRange': 'Longitude must be between -180 and 180',
    'events.errTitleRequired': 'Title is required.',
    'events.errDescriptionRequired': 'Description is required.',
    'events.errCityRequired': 'City is required.',
    'events.errAddressRequired': 'Address is required.',
    'events.errPostalRequired': 'Postal code is required.',
    'events.errPostalFiveDigits': 'Postal code must be a 5-digit number.',
    'events.errEventDateRequired': 'Event date is required.',
    'events.errEventTimeRequired': 'Event time is required.',
    'events.errChargesRequired': 'Charges is required.',
    'events.errChargesNum': 'Charges must be a valid number.',
    'events.errChargesMin': 'Charges cannot be negative.',
    'events.errChargesMax': 'Charges cannot exceed 10,000.',
    'events.errChargesMaxLen': 'Charges cannot exceed 6 characters.',
    'events.helperLngRange': 'Must be between -180 and 180',
    'events.helperLatRange': 'Must be between -90 and 90',
    'events.toastInvalidUrls': 'Please correct the invalid URLs',
    'events.toastUpdated': 'Event updated successfully.',
    'events.toastCreated': 'Event created successfully.',
    'events.toastSaveError': 'Error saving event. Please try again.',
    'events.confirmDelete': 'Are you sure you want to delete this event?',
    'events.toastDeleted': 'Event deleted successfully.',
    'events.toastDeleteError': 'Error deleting event.',
    'events.toastFetchError': 'Error fetching event details',
    'eventTypes.title': 'Event Type',
    'eventTypes.add': 'Add Event Type',
    'eventTypes.empty': 'No event types found.',
    'eventTypes.dialogEdit': 'Edit Event Type',
    'eventTypes.dialogAdd': 'Add Event Type',
    'eventTypes.fieldNamePh': 'e.g. Conference (used as English)',
    'eventTypes.updated': 'Event type updated successfully.',
    'eventTypes.created': 'Event type added successfully.',
    'eventTypes.confirmDelete': 'Are you sure you want to delete this event type?',
    'eventTypes.deleted': 'Event type deleted successfully.',
    'promoTypes.title': 'Promotion Type',
    'promoTypes.add': 'Add Promotion Type',
    'promoTypes.empty': 'No promotion types found.',
    'promoTypes.dialogEdit': 'Edit Promotion Type',
    'promoTypes.dialogAdd': 'Add Promotion Type',
    'promoTypes.fieldNamePh': 'e.g. Seasonal Offer (used as English)',
    'promoTypes.updated': 'Promotion type updated successfully.',
    'promoTypes.created': 'Promotion type added successfully.',
    'promoTypes.confirmDelete': 'Are you sure you want to delete this promotion type?',
    'promoTypes.deleted': 'Promotion type deleted successfully.',
    'serviceSub.title': 'Service Sub Categories',
    'serviceSub.filterCategory': 'Filter by Category',
    'serviceSub.searchPlaceholder': 'Search sub categories...',
    'serviceSub.add': 'Add Sub Category',
    'serviceSub.colEnglish': 'English Name',
    'serviceSub.colGerman': 'German Name',
    'serviceSub.colEnabled': 'Enabled',
    'serviceSub.empty': 'No service sub categories found.',
    'serviceSub.dialogEdit': 'Edit Sub Category',
    'serviceSub.dialogAdd': 'Add New Sub Category',
    'serviceSub.nameEn': 'Name (English)',
    'serviceSub.nameDe': 'Name (German)',
    'serviceSub.fieldCategory': 'Category',
    'serviceSub.toastFill': 'Please fill all required fields',
    'serviceSub.toastUpdated': 'Sub category updated successfully.',
    'serviceSub.toastCreated': 'Sub category created successfully.',
    'serviceSub.toastSaveError': 'Error saving sub category',
    'serviceSub.confirmDelete': 'Are you sure you want to delete this sub category?',
    'serviceSub.toastDeleted': 'Sub category deleted successfully.',
    'serviceSub.toastDeleteError': 'Error deleting sub category',
    'cities.pageTitle': 'Cities',
    'cities.addNew': 'Add New City',
    'cities.colImage': 'Image',
    'cities.colCityCode': 'City Code',
    'cities.colIsEnabled': 'Is Enabled',
    'cities.dialogEdit': 'Edit City',
    'cities.dialogAdd': 'Add New City',
    'cities.fieldCityName': 'City Name',
    'cities.fieldCityCode': 'City Code',
    'cities.fieldImageUrl': 'Image URL',
    'cities.toastUpdated': 'City updated successfully.',
    'cities.toastCreated': 'City created successfully.',
    'cities.toastSaveError': 'Error saving city.',
    'cities.confirmDelete': 'Are you sure you want to delete this city?',
    'cities.toastDeleted': 'City deleted successfully.',
    'cities.toastDeleteError': 'Error deleting city.',
    'districts.title': 'Districts',
    'districts.filterCity': 'Filter by City',
    'districts.searchPlaceholder': 'Search districts...',
    'districts.add': 'Add District',
    'districts.dialogEdit': 'Edit District',
    'districts.dialogAdd': 'Add New District',
    'districts.fieldDistrictName': 'District Name',
    'districts.toastUpdated': 'District updated successfully.',
    'districts.toastCreated': 'District created successfully.',
    'districts.toastSaveError': 'Error saving district.',
    'districts.confirmDelete': 'Are you sure you want to delete this district?',
    'districts.toastDeleted': 'District deleted successfully.',
    'districts.toastDeleteError': 'Error deleting district.',
    'categoriesPage.title': 'Categories',
    'categoriesPage.searchPh': 'Search categories...',
    'categoriesPage.add': 'Add Category',
    'categoriesPage.colTitle': 'Title (EN/DE)',
    'categoriesPage.colDesc': 'Description (EN/DE)',
    'categoriesPage.colColors': 'Colors',
    'categoriesPage.colIcon': 'Icon',
    'categoriesPage.colContact': 'Contact',
    'categoriesPage.colContactInfo': 'Contact Information',
    'categoriesPage.colContactInfoDetails': 'Contact Information Details',
    'categoriesPage.infoIconPrefix': 'Info Icon Available',
    'categoriesPage.hasPrefix': 'Has',
    'categoriesPage.emergencyPrefix': 'Emergency',
    'categoriesPage.noDocuments': 'No documents',
    'categoriesPage.noRecommendations': 'No recommendations',
    'categoriesPage.recCount': '{n} recommendation(s)',
    'categoriesPage.more': '+{n} more',
    'categoriesPage.moreDetails': '+{n} more detail(s)',
    'categoriesPage.noData': 'No data',
    'categoriesPage.noDetails': 'No details',
    'categoriesPage.manageInfo': 'Manage Contact Information',
    'categoriesPage.addInfo': 'Add Contact Information',
    'categoriesPage.manageDetails': 'Manage Contact Information Details',
    'categoriesPage.addDetails': 'Add Contact Information Details',
    'categoriesPage.recommended': 'Recommended',
    'categoriesPage.detailCount': '{n} detail(s)',
    'categoriesPage.dialogEdit': 'Edit Category',
    'categoriesPage.dialogAdd': 'Add New Category',
    'categoriesPage.fieldTitleEn': 'Title (English)',
    'categoriesPage.fieldTitleDe': 'Title (German)',
    'categoriesPage.fieldDescEn': 'Description (English)',
    'categoriesPage.fieldDescDe': 'Description (German)',
    'categoriesPage.fieldBg': 'Background Color',
    'categoriesPage.fieldImgBg': 'Image Background Color',
    'categoriesPage.fieldIcon': 'Icon',
    'categoriesPage.switchInfoIcon': 'Info Icon Available',
    'categoriesPage.switchHasContact': 'Has Contact',
    'categoriesPage.switchEmergency': 'Emergency Contact',
    'categoriesPage.switchCategoryFor': 'Active',
    'categoriesPage.toastUpdated': 'Category updated successfully.',
    'categoriesPage.toastCreated': 'Category created successfully.',
    'categoriesPage.toastSaveError': 'Error saving category.',
    'categoriesPage.confirmDelete': 'Are you sure you want to delete this category?',
    'categoriesPage.toastDeleted': 'Category deleted successfully.',
    'categoriesPage.toastDeleteError': 'Error deleting category.',
    'cinfo.title': 'Contact Information',
    'cinfo.selectCategory': 'Select Category',
    'cinfo.chooseCategory': '— Choose Category —',
    'cinfo.categoryNum': 'Category #{n}',
    'cinfo.refresh': 'Refresh',
    'cinfo.add': 'Add Contact Information',
    'cinfo.selectPrompt': 'Select a category to view its Contact Information.',
    'cinfo.colContactTitle': 'Contact Title',
    'cinfo.colDocTitle': 'Document Title',
    'cinfo.colInfoName': 'Info Name',
    'cinfo.colInfoTitle': 'Info Title',
    'cinfo.colDocValues': 'Document Values',
    'cinfo.colRecTitle': 'Recommendation Title',
    'cinfo.colRecValues': 'Rec. Values',
    'cinfo.colEnabled': 'Enabled',
    'cinfo.emptyFor': 'No contact information found for {name}.',
    'cinfo.dialogEdit': 'Edit Contact Information',
    'cinfo.dialogAdd': 'Add Contact Information',
    'cinfo.fieldCategoryReq': 'Category *',
    'cinfo.fieldContactTitleReq': 'Contact Title *',
    'cinfo.fieldDocTitle': 'Document Title',
    'cinfo.fieldInfoNameReq': 'Info Name *',
    'cinfo.fieldInfoTitle': 'Info Title',
    'cinfo.sectionBasic': 'Basic information',
    'cinfo.sectionDocuments': 'Documents',
    'cinfo.sectionRecommendations': 'Recommendations',
    'cinfo.translationEmpty': '(no title yet)',
    'cinfo.docValuesTitle': 'Document Title Values',
    'cinfo.docValuesHint': 'Enter title & description, then click + or press Enter to add',
    'cinfo.fieldRecTitle': 'Recommendation Title',
    'cinfo.recValuesTitle': 'Recommendation Values',
    'cinfo.recValuesHint': 'Type a value and press Enter or click + to add',
    'cinfo.fieldEnabled': 'Enabled',
    'cinfo.translationsTitle': 'Translations',
    'cinfo.addTranslation': 'Add Translation',
    'cinfo.loadFailed': 'Failed to load contact information.',
    'cinfo.errContactTitle': 'Contact Title is required',
    'cinfo.errInfoName': 'Info Name is required',
    'cinfo.errCategory': 'Please select a valid category.',
    'cinfo.toastSaved': 'Contact Information {action} successfully.',
    'cinfo.actionUpdated': 'updated',
    'cinfo.actionCreated': 'created',
    'cinfo.confirmDelete': 'Delete this Contact Information?',
    'cinfo.deleted': 'Deleted successfully.',
    'cinfo.confirmDeleteTrans': 'Delete translation for {code}?',
    'cinfo.transDeleted': 'Translation deleted.',
    'cinfo.saveError': 'Error saving.',
    'cinfo.deleteError': 'Error deleting.',
    'cinfo.deleteTransError': 'Error deleting translation.',
    'cidetail.title': 'Contact Information Details',
    'cidetail.addDetail': 'Add Detail',
    'cidetail.selectPrompt': 'Select a category to view Contact Information Details.',
    'cidetail.colInfoNote': 'Info Note',
    'cidetail.colRecommended': 'Recommended',
    'cidetail.colSubDetails': 'Sub-Details',
    'cidetail.emptyFor': 'No details found for {name}.',
    'cidetail.dialogEdit': 'Edit Contact Information Detail',
    'cidetail.dialogAdd': 'Add Contact Information Detail',
    'cidetail.subItemsTitle': 'Contact Information Details (Sub-Items)',
    'cidetail.addSubItem': 'Add Sub-Detail Item',
    'cidetail.translations': 'Translations',
    'cidetail.addTranslation': 'Add Translation',
    'cidetail.noTranslationsYet': 'No other languages yet. Click Add Translation for DE, etc.',
    'cidetail.loadWarn': 'Failed to load detail. Using list data.',
    'cidetail.errCategory': 'Category is required',
    'cidetail.errName': 'Name is required',
    'cidetail.errDescription': 'Description is required',
    'cidetail.toastSaved': 'Detail {action} successfully.',
    'cidetail.confirmDelete': 'Delete this Contact Information Detail? This will also remove all its translations.',
    'cidetail.missingDelete': 'Missing Id or CategoryId for delete.',
    'cidetail.deleted': 'Detail deleted successfully.',
    'docsVerify.title': 'Documents Verification',
    'docsVerify.searchLabel': 'Search',
    'docsVerify.searchPh': 'Search by name, email, phone, compliance, or document count',
    'docsVerify.colDocType': 'Document Type',
    'docsVerify.colDocUrl': 'Document URL',
    'docsVerify.colAction': 'Action',
    'docsVerify.empty': 'No pending verification documents found.',
    'docsVerify.viewDoc': 'View Document',
    'docsVerify.review': 'Review',
    'docsVerify.reviewTitle': 'Review Verification',
    'docsVerify.statusPending': 'PENDING',
    'docsVerify.loadFailed': 'Failed to load documents.',
    'docsVerify.errApprovedNotes': 'Please enter review notes for APPROVED status.',
    'docsVerify.errRejectedReason': 'Please enter rejection reason for REJECTED status.',
    'docsVerify.markedAs': 'Document marked as {status}.',
    'docsVerify.reviewFailed': 'Failed to submit review.',
    'docsVerify.fieldReviewNotes': 'Review Notes',
    'docsVerify.fieldRejectionReason': 'Rejection Reason',
    'docsVerify.statusInReview': 'IN_REVIEW (Pending)',
    'docsVerify.statusApproved': 'APPROVED',
    'docsVerify.statusRejected': 'REJECTED',
    'docsVerify.submitReview': 'Submit Review',
    'docsVerify.submitting': 'Submitting...',
    'docsVerify.previewTitle': 'Document Preview',
    'docsVerify.noImage': 'No image available.',
    'docsVerify.colPhone': 'Phone',
    'docsVerify.colDocCount': 'Documents',
    'docsVerify.colCompliance': 'Compliance checked',
    'docsVerify.colPendingDocs': 'Pending',
    'docsVerify.complianceYes': 'Yes',
    'docsVerify.complianceNo': 'No',
    'docsVerify.openDocuments': 'Open documents',
    'docsVerify.userDocsTitle': 'User documents',
    'docsVerify.documentsList': 'Documents',
    'docsVerify.reviewed': 'Done',
    'docsVerify.markCompliance': 'Mark compliance complete',
    'docsVerify.complianceHint': 'Approve every document for this user, then mark compliance or it will be offered automatically.',
    'docsVerify.complianceOk': 'Compliance marked complete for this user.',
    'docsVerify.complianceFailed': 'Could not update compliance status.',
    'docsVerify.complianceNeedAllApproved': 'All documents must be approved before marking compliance.',
    'docsVerify.allApprovedClose': 'All documents are approved and compliance is already set. Dialog closed.',
    'docsVerify.reviewSelected': 'Review Selected',
    'docsVerify.bulkMarkedAs': 'Bulk documents marked as {status}.',
    'docsVerify.bulkReviewTitle': 'Bulk Review',
    'docsVerify.bulkReviewDesc': 'Review {n} selected documents.',
    'users.title': 'Users',
    'users.searchPh': 'Search users...',
    'users.add': 'Add User',
    'users.colName': 'Name',
    'users.colRole': 'Role',
    'users.verified': 'Verified',
    'users.unverified': 'Unverified',
    'users.blocked': 'Blocked',
    'users.dialogEdit': 'Edit User',
    'users.dialogAdd': 'Add New User',
    'users.fieldFirstName': 'First Name',
    'users.fieldLastName': 'Last Name',
    'users.fieldPassword': 'Password',
    'users.switchEmailVerified': 'Email Verified',
    'users.switchBlocked': 'Blocked',
    'users.roleUser': 'User',
    'users.roleAdmin': 'Admin',
    'users.roleAdminUser': 'Admin User',
    'users.roleCustomer': 'Customer',
    'users.roleSuperAdmin': 'Super Admin',
    'users.filterRole': 'Role',
    'users.filterRoleAll': 'All roles',
    'users.confirmDelete': 'Are you sure you want to delete this user?',
    'users.deleteFailed': 'Failed to delete user.',
    'users.deleteTitle': 'Delete user',
    'users.accountType': 'Account Type',
    'users.accountCompany': 'Company',
    'users.accountFreelancer': 'Freelancer',
    'users.fullName': 'Full Name',
    'users.phoneNumber': 'Phone Number',
    'users.serviceType': 'Service Type',
    'users.country': 'Country',
    'users.zipcode': 'Zipcode',
    'users.name': 'Name',
    'users.docProofBusinessReg': 'Proof of Business Registration / Employment Authorization',
    'users.docPassportPermit': 'Passport / Residence Permit',
    'users.companyDocs': 'Company documents',
    'users.freelancerDocs': 'Freelancer documents',
    'users.errEmailRequired': 'Email is required.',
    'users.errFirstLastRequired': 'First name and last name are required.',
    'users.errPhoneRequired': 'Phone number is required.',
    'users.errCountryRequired': 'Country is required.',
    'users.errFullNameRequired': 'Full Name is required.',
    'users.errServiceTypeRequired': 'Service Type is required.',
    'users.errCityRequired': 'City is required.',
    'users.errDistrictRequired': 'District is required.',
    'users.errZipcodeRequired': 'Zipcode is required.',
    'users.errNameRequired': 'Name is required.',
    'users.errCompanyDocsRequired': 'All company documents are required.',
    'users.errFreelancerDocsRequired': 'All freelancer documents are required.',
    'users.toastUserUpdated': 'User updated successfully.',
    'users.toastUserAdded': 'User added successfully.',
    'users.errConflict409': 'Conflict (409): A user with this Email or Phone Number already exists, or conflicting data was submitted.',
    'users.errSaveFailed': 'Error saving user.',
    'cityReg.title': 'City Registration',
    'cityReg.add': 'Add Registration',
    'cityReg.selectCity': 'Select City',
    'cityReg.dialogEdit': 'Edit Registration',
    'cityReg.dialogAdd': 'Add New Registration',
    'cityReg.fieldUrl': 'URL',
    'cityReg.toastFill': 'Please fill in all required fields',
    'cityReg.saveError': 'Error saving registration. Please try again.',
    'cityReg.confirmDelete': 'Are you sure you want to delete this registration?',
    'cityReg.deleteError': 'Error deleting registration. Please try again.',
    'support.title': 'Customer Support',
    'support.searchPh': 'Search customer support...',
    'support.colMessage': 'Message',
    'support.colCategory': 'Category',
    'support.colInquirySource': 'Inquiry source',
    'support.filterCategory': 'Category',
    'support.filterCategoryAll': 'All categories',
    'support.filterInquirySource': 'Inquiry source',
    'support.filterInquirySourceAll': 'All sources',
    'support.fieldCategory': 'Category',
    'support.fieldInquirySource': 'Inquiry source',
    'support.inquirySourceApp': 'App',
    'support.inquirySourceCustomer': 'Customer',
    'support.inquirySourcePlaceholder': 'Select App or Customer',
    'support.colResolved': 'Resolved',
    'support.colPending': 'Pending',
    'support.updateStatusTitle': 'Update Status',
    'support.dialogEdit': 'Edit Support',
    'support.dialogAdd': 'Add New Support',
    'support.fieldMessage': 'Message',
    'support.switchResolved': 'Issue Resolved',
    'support.resolveQuestion': 'Is Issue Resolved?',
    'support.toastFill': 'Please fill in all required fields',
    'support.toastInquirySource': 'Please select an inquiry source (App or Customer).',
    'support.toastEmail': 'Please enter a valid email address',
    'support.saveError': 'Error saving customer support. Please try again.',
    'support.confirmDelete': 'Are you sure you want to delete this customer support?',
    'support.deleteError': 'Error deleting customer support. Please try again.',
    'support.statusError': 'Error updating issue status. Please try again.',
    'support.tooltipStatus': 'Update Status',
    'support.colNotes': 'Notes',
    'support.fieldNotes': 'Notes / Remarks',
    'support.toastStatusOk': 'Status updated successfully.',
    'jobs.title': 'Job Portals',
    'jobs.searchPh': 'Search job portals...',
    'jobs.add': 'Add Job Portal',
    'jobs.colRecommended': 'Recommended',
    'jobs.dialogEdit': 'Edit Job Portal',
    'jobs.dialogAdd': 'Add Job Portal',
    'jobs.switchRecommended': 'Recommended',
    'jobs.toastFill': 'Please fill all required fields',
    'jobs.toastUpdated': 'Job portal updated successfully.',
    'jobs.toastCreated': 'Job portal created successfully.',
    'jobs.toastSaveError': 'Error saving portal',
    'jobs.confirmDelete': 'Are you sure you want to delete this job portal?',
    'jobs.toastDeleted': 'Job portal deleted successfully.',
    'jobs.toastDeleteError': 'Error deleting portal',
    'langSupport.title': 'Language Support',
    'langSupport.searchPh': 'Search languages...',
    'langSupport.add': 'Add Language',
    'langSupport.colLangCode': 'Language Code',
    'langSupport.empty': 'No language records found.',
    'langSupport.dialogEdit': 'Edit Language',
    'langSupport.dialogAdd': 'Add New Language',
    'langSupport.fieldLangCode': 'Language Code',
    'langSupport.fieldLangCodePh': 'e.g. en, de, fr',
    'langSupport.switchActive': 'Is Active',
    'langSupport.toastUpdated': 'Language updated successfully.',
    'langSupport.toastCreated': 'Language created successfully.',
    'langSupport.toastSaveError': 'Error saving language.',
    'langSupport.confirmDelete': 'Are you sure you want to delete this language?',
    'langSupport.toastDeleted': 'Language deleted successfully.',
    'langSupport.toastDeleteError': 'Error deleting language.',
    'cinfo.moreChip': '+{n} more',
    'cinfo.recValuesHint2': 'Enter text, then click + or press Enter to add',
    'cinfo.fieldAddRec': 'Add Recommendation',
    'cinfo.transContactTitle': 'Contact Title (translation)',
    'cinfo.transDocTitle': 'Document Title (translation)',
    'cinfo.transInfoName': 'Info Name',
    'cinfo.transInfoTitle': 'Info Title',
    'cinfo.transDocValues': 'Document Values (translation)',
    'cinfo.transRecTitle': 'Recommendation Title (translation)',
    'cinfo.transRecValues': 'Recommendation Values (translation)',
    'cinfo.fieldAdd': 'Add',
    'cinfo.removeRow': 'Remove',
    'cinfo.deleteTransTitle': 'Delete translation',
    'cinfo.fieldDescShort': 'Desc',
    'common.remove': 'Remove',
    'cidetail.contactInfoSelect': 'Contact Information',
    'cidetail.fieldContactInfo': 'Contact Information',
    'cidetail.deleteTransServer': 'Delete translation from server',
    'cidetail.transName': 'Name (translation)',
    'cidetail.transDescription': 'Description (translation)',
    'cidetail.transInfoNote': 'Info Note (translation)',
    'cidetail.transSubDetails': 'Contact Information Details (translation)',
    'cidetail.fieldNameStar': 'Name *',
    'cidetail.fieldInfoNameStar': 'Info Name *',
    'cidetail.fieldDocumentTitle': 'Document Title',
    'cidetail.documentTitleSelect': 'Select document title',
    'cidetail.documentTitleSelectContactFirst': 'Select contact information first',
    'cidetail.fieldDescriptionStar': 'Description *',
    'cidetail.fieldInfoNote': 'Info Note',
    'cidetail.fieldContactTitle': 'Contact Title',
    'cidetail.colDocumentTitle': 'Document Title',
    'cidetail.colInfoName': 'Info Name',
    'cidetail.errContactInfo': 'Please select contact information',
    'cidetail.noContactInfoForCategory': 'No contact information for this category. Add contact information first.',
    'cidetail.moreChip': '+{n} more',
    'cidetail.errorPrefix': 'Error:',
    'cidetail.unknownError': 'Unknown error',
    'legal.title': 'Legal Documents History',
    'legal.subtitle': 'Manage versioned Privacy Policies and Terms & Conditions',
    'legal.addBtn': 'Add Legal Documents',
    'legal.filterCategory': 'Filter Category',
    'legal.filterPlatform': 'Filter Platform',
    'legal.privacyPolicy': 'Privacy Policy',
    'legal.termsConditions': 'Terms & Conditions',
    'legal.app': 'App',
    'legal.customer': 'Customer',
    'legal.clear': 'Clear',
    'legal.colVersion': 'VERSION',
    'legal.colChanges': 'CHANGES',
    'legal.colEffectiveDate': 'EFFECTIVE DATE',
    'legal.colPlatform': 'PLATFORM',
    'legal.colStatus': 'STATUS',
    'legal.colDocuments': 'DOCUMENTS',
    'legal.active': 'Active',
    'legal.inactive': 'Inactive',
    'legal.view': 'View',
    'legal.dialogTitle': 'Upload New Legal Document',
    'legal.category': 'Category',
    'legal.platformTarget': 'Platform Target',
    'legal.versionLabel': 'Version (e.g. 1.0.0)',
    'legal.selectFile': 'Select .html or .md file',
    'legal.fileNamePrefix': 'File: ',
    'legal.changeSummary': 'Change Of Content (Brief summary)',
    'legal.uploadSave': 'Upload & Save',
    'legal.uploading': 'Uploading...',
    'legal.previewTitle': 'Preview: {category} ({platform})',
    'legal.previewPlaceholder': 'Preview of document content would appear here.',
    'legal.accessDenied': 'Access Denied. Super Admin only.',
    'legal.errLoad': 'Failed to load document history.',
    'legal.errNoContent': 'Please upload a file or enter content.',
    'legal.successUpload': '{category} uploaded successfully!',
    'legal.errUpload': 'Failed to upload document.',
    'legal.errFetchContent': 'Failed to fetch document content.',

    'events.title': 'Events',
    'events.addEvent': 'Add Event',
    'events.searchTitle': 'Search events...',
    'events.trendingEvents': 'Trending Events',
    'events.colEventType': 'Event Type',
    'events.colDescription': 'Description',
    'events.colLocation': 'Location',
    'events.colDateTime': 'Date & Time',
    'events.colCharges': 'Charges',
    'events.colUrls': 'URLs & Media',
    'events.expiredNotice': 'Events Expired',
    'events.dialogAdd': 'Add Event',
    'events.dialogEdit': 'Edit Event',
    'events.dialogView': 'View Event',
    'events.fieldEventTitle': 'Event Title',
    'events.fieldEventType': 'Event Type',
    'events.errEventTypeRequired': 'Event Type is required',
    'events.fieldEventDate': 'Event Date',
    'events.fieldEventTime': 'Event Time',
    'events.fieldCharges': 'Charges',
    'events.fieldRecurrence': 'Recurrence',
    'events.placeholderRecurrence': 'e.g. Daily, Weekly, Monthly',
    'events.fieldLanguage': 'Language',
    'events.placeholderLanguage': 'e.g. English / German',
    'events.fieldMinAge': 'Minimum Age Allowed',
    'events.placeholderMinAge': 'e.g. 18',
    'events.fieldContactPerson': 'Contact Person',
    'events.fieldPersonRole': 'Person Role',
    'events.fieldContactGender': 'Contact Person Gender',
    'events.genderNone': 'None / Unspecified',
    'events.genderFemale': 'Female',
    'events.genderMale': 'Male',
    'events.genderOther': 'Other',
    'events.secPeopleOfEvent': 'People of Event (DJs, MCs, Performers, etc.)',
    'events.emptyPeopleOfEvent': 'No people added yet.',
    'events.placeholderAddPerson': 'Add person name (e.g. DJ Nova)',
    'events.btnAddPerson': 'Add Person',
    'events.secWhatYouGet': 'What You Get (Inclusions)',
    'events.emptyWhatYouGet': 'No inclusion items added yet.',
    'events.placeholderAddWhatYouGet': 'Add inclusion (e.g. Welcome drink)',
    'events.btnAddWhatYouGet': 'Add Item',
    'events.secCoupons': 'Coupons & Offers',
    'events.offer': 'Offer',
    'events.offers': 'Offers',
    'events.untitledOffer': 'Untitled Offer',
    'events.tooltipEditCoupon': 'Edit coupon',
    'events.tooltipDeleteCoupon': 'Delete coupon',
    'events.emptyCouponsTitle': 'No coupons or offers added yet.',
    'events.emptyCouponsSub': 'Fill in the form below to attach an offer to this event.',
    'events.titleEditCoupon': '✏️ Edit Coupon Details',
    'events.titleAddCoupon': '➕ Add New Coupon / Offer',
    'events.lblCouponTitle': 'Coupon Title',
    'events.placeholderCouponTitle': 'e.g. Early bird discount',
    'events.lblCouponCode': 'Coupon Code',
    'events.placeholderCouponCode': 'e.g. BEAT10',
    'events.lblCouponPrice': 'Price / Discount',
    'events.placeholderCouponPrice': 'e.g. 15 EUR or 10% off',
    'events.lblCouponUrl': 'Coupon URL / Link',
    'events.placeholderCouponUrl': 'https://example.com/c1',
    'events.placeholderCouponDesc': 'e.g. 10% off gate price for early bookings',
    'events.btnUpdateCoupon': 'Update Coupon',
    'events.btnAddCoupon': 'Add Coupon',
    'events.secBannerImage': 'Banner Image',
    'events.fieldWebUrlBtn': 'Web URL Button Title',
    'events.placeholderTerms': 'Enter terms and conditions...',
    'events.approvalDialogTitle': 'Update Approval Status',
    'events.toastStatusOk': 'Approval status updated successfully.',
    'events.toastApprovalErrPrefix': 'Approval error',
    'events.toastDeclineNote': 'Decline note is required when declining',
    'events.toastUpdated': 'Event updated successfully.',
    'events.toastCreated': 'Event created successfully.',
    'events.toastDeleted': 'Event deleted successfully.',
    'events.toastSaveError': 'Error saving event.',
    'events.toastDeleteError': 'Error deleting event.',
    'events.confirmDelete': 'Are you sure you want to delete this event?',
    'events.errTitleRequired': 'Title is required',
    'events.errDescriptionRequired': 'Description is required',
    'events.errCityRequired': 'City is required',
    'events.errDistrictRequired': 'District is required',
    'events.errAddressRequired': 'Address is required',
    'events.errAddressAutoFetch': 'Please select address from auto-fetch suggestions',
    'events.errPostalRequired': 'Postal code is required',
    'events.errPostalFiveDigits': 'Postal code must be 5 digits',
    'events.errEventDateRequired': 'Event date is required',
    'events.errEventDatePast': 'Date cannot be in the past',
    'events.errEventTimeRequired': 'Event time is required',
    'events.errEventTimePast': "Time must be in the future for today's events",
    'events.errLatRequired': 'Latitude is required',
    'events.errLatNum': 'Latitude must be a valid number',
    'events.errLatRange': 'Latitude must be between -90 and 90',
    'events.errLngRequired': 'Longitude is required',
    'events.errLngNum': 'Longitude must be a valid number',
    'events.errLngRange': 'Longitude must be between -180 and 180',

    'userActivity.title': 'User Activity & Engagement Analytics',
    'userActivity.subtitle': 'Track and analyze visitor engagements across modules.',
    'userActivity.selectModule': 'Activity Module',
    'userActivity.refreshData': 'Refresh Data',
    'userActivity.downloadXls': 'Download XLS Report',
    'userActivity.kpiTotalVisits': 'Total User Visits',
    'userActivity.kpiUniqueUsers': 'Unique Users',
    'userActivity.kpiActiveEntities': 'Active',
    'userActivity.kpiActiveCategories': 'Active Categories',
    'userActivity.trendChartTitle': 'Activity Trend',
    'userActivity.trendChartSubtitle': 'Visit volume over selected period',
    'userActivity.trendNoData': 'No trend data available for activity.',
    'userActivity.topEntitiesTitle': 'Top',
    'userActivity.topEntitiesNoData': 'No top activity data available',
    'userActivity.periodDay': 'Day',
    'userActivity.periodWeek': 'Week',
    'userActivity.periodMonth': 'Month',
    'userActivity.periodYear': 'Year',
    'userActivity.currentYear': 'Current Year',
    'userActivity.today': 'Today',
    'userActivity.allWeeks': 'All Weeks',
    'userActivity.currentWeek': 'Current Week',
    'userActivity.week': 'Week',
    'userActivity.filterPeriod': 'Analytics Filter Period',
    'userActivity.filterSubtitle': 'Select year, month, or week to filter overall analytics data across all charts',
    'userActivity.selectYear': 'Year',
    'userActivity.selectMonth': 'Month',
    'userActivity.selectWeek': 'Week',
    'userActivity.filterTitle': 'Filter Activity',
    'userActivity.searchPlaceholder': 'Search Name or Email',
    'userActivity.typeToFilter': 'Type to filter...',
    'userActivity.categoryLabel': 'Category',
    'userActivity.allCategories': 'All Categories',
    'userActivity.selectDate': 'Select Date',
    'userActivity.clearFilters': 'Clear Filters',
    'userActivity.colInformation': 'Information',
    'userActivity.colCategory': 'Category',
    'userActivity.colCity': 'City',
    'userActivity.colTotalVisits': 'Total Visits',
    'userActivity.colUniqueVisitors': 'Unique Visitors',
    'userActivity.colLastActivity': 'Last Activity Date',
    'userActivity.colAction': 'Action',
    'userActivity.viewDetailsTooltip': 'View Activity Details',
    'userActivity.noRecords': 'No Activity Records Found',
    'userActivity.noRecordsSub': 'Try adjusting your search query or clear filters to view data.',
    'userActivity.modalTitle': 'Visitor Activity Details',
    'userActivity.modalSub': 'List of users and visitors who interacted with this item.',
    'userActivity.modalLogTitle': 'Visitor Activity Log',
    'userActivity.colVisitor': 'Visitor',
    'userActivity.colEmail': 'Email',
    'userActivity.colVisitedDate': 'Visited Date & Time',
    'userActivity.noVisitorLogs': 'No visitor activity logs found for this item.',
    'userActivity.close': 'Close',
    'userActivity.guest': 'Guest',
    'userActivity.user': 'User',
    'userActivity.xlsSuccess': 'XLS report downloaded successfully.',
    'userActivity.xlsError': 'Failed to download XLS report.',
    'userActivity.detailError': 'Error loading visitor activity details.',
    'userActivity.loadError': 'Failed to load user activity data.',
  },
  de: {
    'app.title': 'Welivin',
    'common.clearFilters': 'Filter zurücksetzen',
    'common.clear': 'Zurücksetzen',
    'common.refresh': 'Aktualisieren',
    'common.add': 'Hinzufügen',
    'common.edit': 'Bearbeiten',
    'common.delete': 'Löschen',
    'common.deleting': 'Löschen...',
    'common.save': 'Speichern',
    'common.saving': 'Speichern...',
    'common.update': 'Aktualisieren',
    'common.cancel': 'Abbrechen',
    'common.all': 'Alle',
    'common.active': 'Aktiv',
    'common.inactive': 'Inaktiv',
    'common.actions': 'Aktionen',
    'common.search': 'Suchen',
    'common.loading': 'Wird geladen...',
    'nav.userReports': 'Berichte',
    'nav.userActivity': 'Benutzeraktivität',
    'nav.ratingModules': 'Bewertungsmodule-Einstellungen',
    'nav.providerApplications': 'Anbieter-Bewerbungen',
    'nav.providerNotifications': 'Anbieter-Benachrichtigungen',
    'nav.referralLinks': 'Empfehlungslinks',
    'nav.contactGoogleRating': 'Google-Bewertungen',
    'nav.contactInquiries': 'Kontaktanfragen',

    'dashboard.title': 'Dashboard-Übersicht',
    'dashboard.welcome': 'Systemmetriken, Traffic-Analysen & Betriebsstatus',
    'dashboard.statUser': 'Benutzer',
    'dashboard.statCity': 'Städte',
    'dashboard.statEvent': 'Veranstaltungen',
    'dashboard.statPromotion': 'Aktionen',
    'dashboard.statContact': 'Kontakte',
    'dashboard.statAccommodation': 'Unterkünfte',
    'dashboard.total': 'Gesamt',
    'dashboard.active': 'Aktiv',
    'dashboard.approved': 'Genehmigt',
    'dashboard.rejected': 'Abgelehnt',
    'dashboard.inactive': 'Inaktiv',
    'dashboard.newThisMonth': 'Neu in diesem Monat',
    'dashboard.newThisPeriod': 'Neu',
    'dashboard.pending': 'Ausstehend',
    'dashboard.periodDay': 'Tag',
    'dashboard.periodMonth': 'Monat',
    'dashboard.periodYear': 'Jahr',
    'dashboard.allMonths': 'Alle Monate',
    'dashboard.selectMonth': 'Monat auswählen',
    'months.january': 'Januar',
    'months.february': 'Februar',
    'months.march': 'März',
    'months.april': 'April',
    'months.may': 'Mai',
    'months.june': 'Juni',
    'months.july': 'Juli',
    'months.august': 'August',
    'months.september': 'September',
    'months.october': 'Oktober',
    'months.november': 'November',
    'months.december': 'Dezember',
    'dashboard.activityOverview': 'Plattform-Aktivitätstrends',
    'dashboard.activityOverviewSubtitle': 'Plattformwachstum und Besuchermetriken',
    'dashboard.totalUserVisits': 'Gesamte Benutzerbesuche',
    'dashboard.totalUniqueVisitors': 'Eindeutige Besucher insgesamt',
    'dashboard.activityMetrics': 'Aktivitätsmetriken',
    'dashboard.contactVisitors': 'Kontaktbesucher',
    'dashboard.eventVisitors': 'Veranstaltungsbesucher',
    'dashboard.promotionVisitors': 'Aktionsbesucher',
    'dashboard.accommodationVisitors': 'Unterkunftsbesucher',
    'dashboard.platformUserVisitsTitle': 'Android & iOS Benutzerbesuche',
    'dashboard.platformUserVisitsSubtitle': 'Aufschlüsselung des Plattform-Traffics nach Zeitraum',
    'dashboard.categoryBreakdown': 'Kategorie-Aufschlüsselung',
    'dashboard.noCategoryData': 'Keine Kategoriedaten verfügbar',
    'dashboard.totalItems': 'Gesamte Elemente',
    'dashboard.moduleHealthTitle': 'Modul-Status & Volumen-Vergleich',
    'dashboard.moduleHealthSubtitle': 'Echtzeit-Entitätszahlen & Betriebsstatus über Systemmodule',
    'dashboard.totalRecords': 'Gesamte Datensätze',
    'dashboard.activeEntities': 'Genehmigte Entitäten',
    'dashboard.pendingApprovals': 'Ausstehende Genehmigungen',
    'dashboard.totalVolume': 'Gesamtvolumen',
    'dashboard.activeRate': 'Aktivitätsrate',
    'dashboard.activeLabel': 'aktiv',
    'dashboard.moduleSuffix': 'Modul',
    'dashboard.recentActivity': 'Neueste Aktivität',
    'dashboard.recentActivitySubtitle': 'Neueste Systemaktionen & Genehmigungen',
    'dashboard.noRecentActivity': 'Keine aktuellen Aktivitäten aufgezeichnet',
    'dashboard.cityDialogTitle': 'Städtestatistik-Aufschlüsselung',
    'dashboard.selectCity': 'Stadt auswählen',
    'dashboard.periodPrefix': 'Zeitraum',
    'dashboard.totalVisits': 'Gesamtbesuche',
    'dashboard.pendingAction': 'Ausstehende Aktion',
    'dashboard.errorLoad': 'Fehler beim Laden der Statistiken',
    'dashboard.errorLoadData': 'Fehler beim Laden der Dashboard-Daten',
    'nav.accommodations': 'Unterkünfte',
    'nav.promotions': 'Aktionen',
    'nav.contacts': 'Kontakte',
    'nav.events': 'Veranstaltungen',

    'contactGoogleRating.title': 'Google-Bewertungen',
    'contactGoogleRating.subtitle': 'Verwalten Sie Google-Bewertungen, Gesamtzahl der Bewertungen und Rezensions-URLs für Anbieter und Kontakte.',
    'contactGoogleRating.addRating': 'Google-Bewertung hinzufügen',
    'contactGoogleRating.searchPlaceholder': 'Suchen nach Kontaktname, ID oder Rezensions-URL...',
    'contactGoogleRating.statusLabel': 'Status',
    'contactGoogleRating.colContact': 'Titel',
    'contactGoogleRating.colRating': 'Google-Bewertung',
    'contactGoogleRating.colTotalRatings': 'Gesamte Rezensionen',
    'contactGoogleRating.colReviewUrl': 'Rezensions-URL',
    'contactGoogleRating.colStatus': 'Status',
    'contactGoogleRating.loading': 'Google-Bewertungen werden geladen...',
    'contactGoogleRating.noDataTitle': 'Keine Google-Bewertungen gefunden',
    'contactGoogleRating.noDataSubtitle': 'Klicken Sie auf „Google-Bewertung hinzufügen“, um eine Bewertung für einen Kontakt zu konfigurieren.',
    'contactGoogleRating.dialogAddTitle': 'Kontakt-Google-Bewertung hinzufügen',
    'contactGoogleRating.dialogEditTitle': 'Kontakt-Google-Bewertung bearbeiten',
    'contactGoogleRating.fieldContact': 'Kontakt / Anbieter auswählen *',
    'contactGoogleRating.fieldRating': 'Google-Bewertungsnote (0.0 - 5.0) *',
    'contactGoogleRating.fieldTotalRatings': 'Anzahl der Rezensionen *',
    'contactGoogleRating.fieldReviewUrl': 'Google-Rezensions-URL',
    'contactGoogleRating.fieldIsActive': 'Ist Bewertung aktiv',
    'contactGoogleRating.confirmDeleteTitle': 'Löschen bestätigen',
    'contactGoogleRating.confirmDeleteText': 'Sind Sie sicher, dass Sie die Google-Bewertungskonfiguration löschen möchten für',
    'contactGoogleRating.toastCreated': 'Google-Bewertung erfolgreich erstellt.',
    'contactGoogleRating.toastUpdated': 'Google-Bewertung erfolgreich aktualisiert.',
    'contactGoogleRating.toastDeleted': 'Google-Bewertung erfolgreich gelöscht.',
    'contactGoogleRating.toastError': 'Google-Bewertung konnte nicht gespeichert werden.',
    'contactGoogleRating.toastDeleteError': 'Google-Bewertung konnte nicht gelöscht werden.',
    'contactGoogleRating.toastFetchError': 'Google-Bewertungsdaten konnten nicht geladen werden.',
    'contactGoogleRating.errContactRequired': 'Bitte wählen Sie einen Kontakt aus.',
    'contactGoogleRating.errRatingInvalid': 'Die Bewertung muss zwischen 0 und 5 liegen.',
    'contactGoogleRating.errTotalRatingsInvalid': 'Die Gesamtanzahl der Bewertungen muss 0 oder größer sein.',
    'contactGoogleRating.errUrlInvalid': 'Bitte geben Sie eine gültige URL ein, die mit http:// oder https:// beginnt.',

    'referralLink.title': 'Empfehlungslinks',
    'referralLink.subtitle': 'Verwalten Sie Empfehlungslinks für Kontakte, Veranstaltungen, Aktionen und Unterkünfte.',
    'referralLink.add': 'Empfehlungslink hinzufügen',
    'referralLink.create': 'Empfehlungslink erstellen',
    'referralLink.edit': 'Empfehlungslink bearbeiten',
    'referralLink.update': 'Link aktualisieren',
    'referralLink.delete': 'Empfehlungslink löschen',
    'referralLink.noItems': 'Keine Empfehlungslinks gefunden',
    'referralLink.moduleKey': 'Modul',
    'referralLink.entityId': 'Entitäts-ID',
    'referralLink.selectEntity': 'Entität auswählen',
    'referralLink.label': 'Link-Bezeichnung',
    'referralLink.summary': 'Zusammenfassung',
    'referralLink.url': 'Empfehlungs-URL',
    'referralLink.colTitle': 'Titel',
    'referralLink.colLabel': 'Bezeichnung',
    'referralLink.colSummary': 'Zusammenfassung',
    'referralLink.colUrl': 'Empfehlungs-URL',
    'referralLink.colOpenCount': 'Aufrufanzahl',
    'referralLink.colStatus': 'Status',
    'referralLink.colActions': 'Aktionen',
    'referralLink.isActive': 'Ist aktiv',
    'referralLink.openCount': 'Aufrufanzahl',
    'referralLink.createdDT': 'Erstellungsdatum',
    'referralLink.updatedDT': 'Aktualisierungsdatum',
    'referralLink.toastCreated': 'Empfehlungslink erfolgreich erstellt.',
    'referralLink.toastUpdated': 'Empfehlungslink erfolgreich aktualisiert.',
    'referralLink.toastDeleted': 'Empfehlungslink erfolgreich gelöscht.',
    'referralLink.toastError': 'Empfehlungslink konnte nicht gespeichert werden.',
    'referralLink.toastDeleteError': 'Empfehlungslink konnte nicht gelöscht werden.',
    'referralLink.confirmDelete': 'Möchten Sie diesen Empfehlungslink wirklich löschen?',

    'providerNotifications.title': 'Anbieter-Benachrichtigungen',
    'providerNotifications.subtitle': 'Überprüfen, genehmigen, lehnen Sie ab, löschen und senden Sie benutzerspezifische Anbieter-Benachrichtigungen.',
    'providerNotifications.searchPh': 'Titel, Nachricht, Anbietername oder E-Mail suchen...',
    'providerNotifications.filterStatus': 'Nach Status filtern',
    'providerNotifications.colProvider': 'Anbieter-Info',
    'providerNotifications.colCategory': 'Kategorie',
    'providerNotifications.colTitle': 'Benachrichtigungstitel',
    'providerNotifications.colMessage': 'Nachricht / Inhalt',
    'providerNotifications.colStatus': 'Status',
    'providerNotifications.colDate': 'Erstellungsdatum',
    'providerNotifications.colActions': 'Aktionen',
    'providerNotifications.emptyTitle': 'Keine Anbieter-Benachrichtigungen gefunden',
    'providerNotifications.approve': 'Genehmigen',
    'providerNotifications.reject': 'Ablehnen (Hinweis erforderlich)',
    'providerNotifications.createBtn': 'Benachrichtigung erstellen',
    'providerNotifications.statusPending': 'Ausstehend',
    'providerNotifications.statusApproved': 'Genehmigt',
    'providerNotifications.statusRejected': 'Abgelehnt',
    'providerNotifications.toastApproved': 'Anbieter-Benachrichtigung erfolgreich genehmigt.',
    'providerNotifications.toastRejected': 'Anbieter-Benachrichtigung erfolgreich abgelehnt.',
    'providerNotifications.toastDeleted': 'Anbieter-Benachrichtigung erfolgreich gelöscht.',
    'providerNotifications.toastCreated': 'Neue Anbieter-Benachrichtigung erfolgreich erstellt.',
    'providerNotifications.toastStatusUpdated': 'Benachrichtigungsstatus erfolgreich aktualisiert.',
    'providerNotifications.updateStatus': 'Status aktualisieren',
    'providerNotifications.errNoteRequired': 'Begründung ist obligatorisch! Bitte geben Sie einen Grund für die Ablehnung an.',
    'providerNotifications.dialogCreateTitle': 'Anbieter-Benachrichtigung erstellen',
    'providerNotifications.fieldCategory': 'Kategorie (Zieltyp)',
    'providerNotifications.selectCategoryNone': 'Keine / Allgemein',
    'providerNotifications.selectCategoryContact': 'Kontakt',
    'providerNotifications.selectCategoryPromotion': 'Aktion',
    'providerNotifications.selectCategoryEvent': 'Veranstaltung',
    'providerNotifications.selectTargetLabel': 'Auswählen',
    'providerNotifications.selectTargetLoading': 'Wird geladen',
    'providerNotifications.selectTargetEmpty': 'Keine Elemente gefunden',
    'providerNotifications.fieldTitle': 'Benachrichtigungstitel',
    'providerNotifications.fieldTitlePh': 'Benachrichtigungstitel eingeben...',
    'providerNotifications.fieldMessage': 'Benachrichtigungstext',
    'providerNotifications.fieldMessagePh': 'Benachrichtigungstext eingeben...',
    'providerNotifications.btnSendCreate': 'Senden / Erstellen',
    'providerNotifications.btnCancel': 'Abbrechen',
    'providerNotifications.btnClose': 'Schließen',
    'providerNotifications.viewTitle': 'Benachrichtigungsdetails',
    'providerNotifications.viewLoading': 'Benachrichtigungsdetails werden geladen...',
    'providerNotifications.viewProviderName': 'Anbieter-Name',
    'providerNotifications.viewProviderEmail': 'Anbieter-E-Mail',
    'providerNotifications.viewTargetCategory': 'Zielkategorie (Typ)',
    'providerNotifications.viewServiceTitle': 'Diensttitel',
    'providerNotifications.viewMessageContent': 'Nachrichteninhalt',
    'providerNotifications.viewNote': 'Genehmigungs- / Ablehnungshinweis',
    'providerNotifications.viewCreatedDate': 'Erstellungsdatum',
    'providerNotifications.viewSentDate': 'Sendedatum',
    'providerNotifications.dialogDeleteTitle': 'Benachrichtigung löschen',
    'providerNotifications.dialogDeleteMsg': 'Sind Sie sicher, dass Sie diesen Anbieter-Benachrichtigungseintrag löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    'providerNotifications.btnDelete': 'Löschen',
    'providerNotifications.optionGeneric': 'Allgemeine Benachrichtigung',
    'providerNotifications.optionCustom': 'Benutzerdefinierte Benachrichtigung',
    'providerNotifications.colSender': 'Absender-Info',
    'providerNotifications.colModule': 'Modul',
    'providerNotifications.colType': 'Typ',
    'providerNotifications.fieldLookbackDays': 'Rückmeldetage',
    'providerNotifications.fieldLookbackDaysPh': 'z. B. 30',
    'providerNotifications.tabAll': 'Alle Benachrichtigungen',
    'providerNotifications.tabGeneric': 'Allgemeine Benachrichtigungen',
    'providerNotifications.tabCustom': 'Benutzerdefinierte Benachrichtigungen',
    'providerNotifications.genericDesc': 'Übertragung an Kategorie-Zielgruppe ohne bestimmte Entität',
    'providerNotifications.customDesc': 'Gezielte Benachrichtigung für einen bestimmten Dienstanbieter / Entität',
    'providerNotifications.notificationType': 'Benachrichtigungstyp',
    'providerNotifications.filterModule': 'Nach Modul filtern',
    'providerNotifications.filterCategory': 'Nach Kategorie filtern',
    'providerNotifications.allModules': 'Alle Module',
    'providerNotifications.allCategories': 'Alle Kategorien',

    'providerApplications.title': 'Anbieter-Bewerbungen',
    'providerApplications.subtitle': 'Überprüfen und verwalten Sie von Anbietern eingereichte Bewerbungen.',
    'providerApplications.searchPh': 'Suche nach Name, Unternehmen, Kategorie, E-Mail, Telefon...',
    'providerApplications.colAppId': 'ID',
    'providerApplications.colBusinessName': 'Unternehmensname',
    'providerApplications.colApplicant': 'Bewerber',
    'providerApplications.colCategory': 'Kategorie',
    'providerApplications.colContact': 'Kontaktinfo',
    'providerApplications.colIntroCall': 'Erstgespräch',
    'providerApplications.colSubmitted': 'Eingereicht am',
    'providerApplications.colActions': 'Aktionen',
    'providerApplications.emptyTitle': 'Keine Anbieter-Bewerbungen gefunden',

    'ratingModules.title': 'Bewertungsmodule-Einstellungen',
    'ratingModules.subtitle': 'Konfigurieren Sie Bewertungen, Rezensionskommentare, Intervallstunden und automatische Cron-Auslöser für Module.',
    'ratingModules.addModule': 'Modul hinzufügen',
    'ratingModules.colModuleName': 'Modulname',
    'ratingModules.colModuleKey': 'Modulschlüssel',
    'ratingModules.colRatingStatus': 'Bewertungsstatus',
    'ratingModules.colCommentsStatus': 'Kommentarstatus',
    'ratingModules.colIntervalHours': 'Intervall (Stunden)',
    'ratingModules.colCronStatus': 'Cron-Status',
    'ratingModules.colLastCronRun': 'Letzter Cron-Lauf',
    'ratingModules.colActions': 'Aktionen',
    'ratingModules.ratingEnabled': 'Bewertung aktiviert',
    'ratingModules.commentsEnabled': 'Kommentare aktiviert',
    'ratingModules.cronEnabled': 'Cron aktiviert',
    'ratingModules.dialogAddTitle': 'Neues Modul hinzufügen',
    'ratingModules.dialogEditTitle': 'Modul bearbeiten',
    'ratingModules.fieldDisplayName': 'Anzeigename',
    'ratingModules.fieldModuleKey': 'Modulschlüssel',
    'ratingModules.fieldIntervalHours': 'Intervallstunden',
    'ratingModules.fieldSortOrder': 'Sortierreihenfolge',
    'ratingModules.toastUpdated': 'Moduleinstellungen erfolgreich aktualisiert.',
    'ratingModules.toastCreated': 'Modul erfolgreich erstellt.',
    'ratingModules.toastError': 'Fehler beim Aktualisieren der Moduleinstellungen.',
    'ratingModules.emptyTitle': 'Keine Bewertungsmodule gefunden',
    'ratingModules.emptySubtitle': 'Klicken Sie auf "Modul hinzufügen", um Ihr erstes Bewertungsmodul zu konfigurieren.',
    'ratingModules.errDisplayNameRequired': 'Bitte geben Sie einen Anzeigenamen ein.',

    'userReports.title': 'Berichte',
    'userReports.subtitle': 'Überprüfen Sie von Benutzern und Anbietern gemeldete Berichte.',
    'userReports.searchPlaceholder': 'Titel, E-Mail, Berichtstyp suchen...',
    'userReports.searchPlaceholderProvider': 'Melder, gemeldeten Benutzer, E-Mail, Typ suchen...',
    'userReports.filterCategory': 'Berichtskategorie',
    'userReports.allCategories': 'Alle Kategorien',
    'userReports.filterReportType': 'Berichtstyp',
    'userReports.allTypes': 'Alle Berichtstypen',
    'userReports.userReports': 'Benutzerbericht',
    'userReports.providerReports': 'Anbieterbericht',
    'userReports.colReporterName': 'Name des Melders',
    'userReports.colReporterEmail': 'E-Mail des Melders',
    'userReports.colReportedUser': 'Gemeldeter Benutzer',
    'userReports.colReportType': 'Berichtstyp',
    'userReports.colDescription': 'Beschreibung',
    'userReports.colReportTime': 'Meldezeit',
    'userReports.colStatus': 'Status',
    'userReports.colActions': 'Aktionen',
    'userReports.colTitle': 'Titel',
    'userReports.colEmail': 'E-Mail',
    'userReports.colReportCategory': 'Berichtskategorie',
    'userReports.detailUserTitle': 'Details zum Benutzerbericht',
    'userReports.detailProviderTitle': 'Details zum Anbieterbericht',
    'userReports.secReporterDetails': 'ANGABEN ZUM MELDER',
    'userReports.secReportedUserDetails': 'ANGABEN ZUM GEMELDETEN BENUTZER',
    'userReports.secReportInfo': 'BERICHTSINFORMATIONEN',
    'userReports.secDescription': 'BESCHREIBUNG',
    'userReports.secReportsAgainstUser': 'Berichte gegen diesen Benutzer',
    'userReports.lblReporterName': 'NAME DES MELDERS',
    'userReports.lblReporterEmail': 'E-MAIL DES MELDERS',
    'userReports.lblReportedUserName': 'NAME DES GEMELDETEN BENUTZERS',
    'userReports.lblReportedUserEmail': 'E-MAIL DES GEMELDETEN BENUTZERS',
    'userReports.lblReportType': 'BERICHTSTYP',
    'userReports.lblReportCategory': 'BERICHTSKATEGORIE',
    'userReports.lblReportTime': 'MELDEZEIT',
    'userReports.lblUserBlockStatus': 'BENUTZER-BLOCKSTATUS',
    'userReports.lblRelatedContact': 'VERKNÜPFTER KONTAKT',
    'userReports.lblTitle': 'TITEL',
    'userReports.statusBlocked': 'Blockiert',
    'userReports.statusUnblocked': 'Freigegeben',
    'userReports.statusUpdating': 'Wird aktualisiert...',
    'userReports.blockUser': 'Benutzer blockieren',
    'userReports.unblockUser': 'Benutzer freigeben',
    'userReports.noDescription': 'Keine Beschreibung vorhanden.',
    'userReports.noHistoryFound': 'Keine vorherigen Berichte für diesen Benutzer gefunden.',
    'header.notifications': 'Benachrichtigungen',

    'header.markAllRead': 'Alle als gelesen markieren',
    'header.viewAllNotifications': 'Alle Benachrichtigungen anzeigen',
    'notifications.title': 'Alle Benachrichtigungen',
    'notifications.filterByCategory': 'Nach Kategorie filtern',
    'notifications.markAllRead': 'Alle als gelesen markieren',
    'notifications.noNotifications': 'Keine Benachrichtigungen gefunden.',
    'notifications.status.read': 'Gelesen',
    'notifications.status.unread': 'Ungelesen',
    'notifications.category.all': 'Alle',
    'notifications.category.accommodation': 'Unterkunft',
    'notifications.category.customer_registration': 'Kundenregistrierung',
    'notifications.category.documentation': 'Dokumentation',
    'notifications.category.promotion': 'Aktion',
    'notifications.category.event': 'Veranstaltungen',
    'notifications.category.contact': 'Kontakt',
    'notifications.category.user': 'Benutzer',
    'notifications.category.support': 'Kundensupport',
    'header.email': 'E-Mail',
    'header.role': 'Rolle',
    'header.logout': 'Abmelden',
    'header.signOut': 'Vom Konto abmelden',
    'header.language': 'Sprache',
    'header.lang.en': 'Englisch',
    'header.lang.de': 'Deutsch',
    'header.changeName': 'Namen ändern',
    'header.changePassword': 'Passwort ändern',
    'header.dialogChangeName': 'Namen aktualisieren',
    'header.dialogChangePassword': 'Passwort aktualisieren',
    'header.currentName': 'Aktueller Name',
    'header.newFirstName': 'Vorname',
    'header.newLastName': 'Nachname',
    'header.oldPassword': 'Aktuelles Passwort',
    'header.newPassword': 'Neues Passwort',
    'header.confirmPassword': 'Neues Passwort bestätigen',
    'header.cancel': 'Abbrechen',
    'header.save': 'Speichern',
    'header.nameRequired': 'Bitte mindestens Vor- oder Nachnamen eingeben.',
    'header.fillAllPassword': 'Bitte alle Passwortfelder ausfüllen.',
    'header.passwordMismatch': 'Neues Passwort und Bestätigung stimmen nicht überein.',
    'header.nameUpdated': 'Ihr Name wurde gespeichert.',
    'header.passwordUpdated': 'Ihr Passwort wurde aktualisiert.',
    'header.updateFailed': 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
    'header.missingUserId': 'In Ihrer Sitzung fehlen Kontodaten. Bitte erneut anmelden.',
    'notif.eventRequest': 'Neue Veranstaltungsanfrage',
    'notif.eventRequestDesc': 'Sommer-Musikfestival benötigt Freigabe',
    'notif.registration': 'Registrierung genehmigt',
    'notif.registrationDesc': 'Neuer Benutzer John Doe wurde genehmigt',
    'notif.system': 'Systemhinweis',
    'notif.systemDesc': 'Hoher Traffic auf der Aktionsseite',
    'notif.failed': 'Fehlgeschlagene Aktion',
    'notif.failedDesc': 'Kontaktaktualisierung fehlgeschlagen für ID: 12345',
    'time.minutesAgo': 'vor 2 Minuten',
    'time.hourAgo': 'vor 1 Stunde',
    'time.hours3': 'vor 3 Stunden',
    'time.hours5': 'vor 5 Stunden',
    'nav.dashboard': 'Übersicht',
    'nav.promotions': 'Aktionen',
    'nav.contacts': 'Kontakte',
    'nav.accommodation': 'Unterkunft',
    'nav.accommodationFacilities': 'Ausstattung Unterkunft',
    'nav.accommodationTypes': 'Unterkunftsart',
    'nav.events': 'Veranstaltungen',
    'nav.eventTypes': 'Veranstaltungstyp',
    'nav.promotionTypes': 'Aktionstyp',
    'nav.serviceSubCategories': 'Service-Unterkategorien',
    'nav.cities': 'Städte',
    'nav.districts': 'Bezirke',
    'nav.categories': 'Kategorien',
    'nav.contactInformation': 'Kontaktinformationen',
    'nav.contactInfoDetails': 'Kontakt-Details',
    'nav.documentsVerification': 'Dokumentenprüfung',
    'nav.users': 'Benutzer',
    'nav.cityRegistration': 'Stadtanmeldung',
    'nav.customerSupport': 'Kundensupport',
    'nav.jobPortals': 'Jobportale',
    'nav.languageSupport': 'Sprachunterstützung',
    'nav.legalPages': 'Rechtliche Seiten',
    'nav.providerClaims': 'Kontaktansprüche',
    'providerClaims.title': 'Kontaktansprüche',
    'providerClaims.searchPh': 'Ansprüche nach Name oder E-Mail suchen...',
    'providerClaims.colContactTitle': 'Kontakt-Titel',
    'providerClaims.colFullName': 'Vollständiger Name',
    'providerClaims.colRole': 'Rolle',
    'providerClaims.colBusinessEmail': 'Geschäftliche E-Mail',
    'providerClaims.colPhoneNumber': 'Telefonnummer',
    'providerClaims.colProofOfOwnership': 'Eigentumsnachweis',
    'providerClaims.colDocument': 'Dokument',
    'providerClaims.colStatus': 'Status',
    'providerClaims.colActions': 'Aktionen',
    'providerClaims.btnApproveClaim': 'Anspruch genehmigen',
    'providerClaims.btnApprove': 'Genehmigen',
    'providerClaims.btnReject': 'Ablehnen',
    'providerClaims.toastApproved': 'Anspruch erfolgreich genehmigt.',
    'providerClaims.toastRejected': 'Anspruch erfolgreich abgelehnt.',
    'providerClaims.toastApproveError': 'Fehler beim Genehmigen des Anspruchs. Bitte versuchen Sie es erneut.',
    'providerClaims.empty': 'Keine Kontaktansprüche gefunden.',
    'providerClaims.confirmApprove': 'Sind Sie sicher, dass Sie diesen Kontaktanspruch genehmigen möchten?',
    'providerClaims.approveTitle': 'Kontaktanspruch genehmigen',

    'contactInquiries.title': 'Kontaktanfragen',
    'contactInquiries.subtitle': 'Eingehende Kontaktanfragen prüfen und Nachrichten an Anbieter freigeben',
    'contactInquiries.searchPlaceholder': 'Nach Kontakt, Absender, E-Mail, Nachricht suchen...',
    'contactInquiries.filterCategory': 'Kategorie',
    'contactInquiries.allCategories': 'Alle Kategorien',
    'contactInquiries.filterContact': 'Kontakt',
    'contactInquiries.allContacts': 'Alle Kontakte',
    'contactInquiries.filterReleaseStatus': 'Freigabestatus',
    'contactInquiries.filterContactVerification': 'Kontaktverifizierung',
    'contactInquiries.filterContactId': 'Nach Kontakt-ID filtern',
    'contactInquiries.all': 'Alle Status',
    'contactInquiries.allVerification': 'Alle Verifizierungen',
    'contactInquiries.released': 'Freigegeben',
    'contactInquiries.unreleased': 'Freigabe ausstehend',
    'contactInquiries.verified': 'Verifiziert',
    'contactInquiries.unverified': 'Nicht verifiziert',
    'contactInquiries.colInquiryId': '# ID',
    'contactInquiries.colContact': 'Empfänger-Kontakt',
    'contactInquiries.colSender': 'Absender',
    'contactInquiries.colMessage': 'Nachricht',
    'contactInquiries.colCreatedAt': 'Empfangsdatum',
    'contactInquiries.colContactVerified': 'Kontaktstatus',
    'contactInquiries.colReleaseStatus': 'Freigabestatus',
    'contactInquiries.colProgressStatus': 'Bearbeitungsstatus',
    'contactInquiries.colActions': 'Aktionen',
    'contactInquiries.btnRelease': 'Freigeben',
    'contactInquiries.btnReleasing': 'Wird freigegeben...',
    'contactInquiries.btnConfirmRelease': 'Bestätigen & E-Mail versenden',
    'contactInquiries.btnViewDetails': 'Details anzeigen',
    'contactInquiries.btnReleaseTooltip': 'Anfrage freigeben und E-Mail an Kontakt senden',
    'contactInquiries.releaseDialogTitle': 'Kontaktanfrage freigeben',
    'contactInquiries.releaseDialogNotice': 'Durch die Freigabe dieser Anfrage wird die E-Mail mit der Absendernachricht sofort an den Kontakt gesendet.',
    'contactInquiries.releaseSuccess': 'Kontaktanfrage #{id} wurde erfolgreich freigegeben und versendet!',
    'contactInquiries.loadFailed': 'Kontaktanfragen konnten nicht geladen werden.',
    'contactInquiries.noInquiriesFound': 'Keine Kontaktanfragen gefunden, die Ihren Filtern entsprechen.',
    'contactInquiries.detailsTitle': 'Anfragedetails',
    'contactInquiries.contactDetails': 'Empfänger-Kontaktinformationen',
    'contactInquiries.senderDetails': 'Absenderinformationen',
    'contactInquiries.inquiryContent': 'Inhalt der Anfrage',
    'contactInquiries.releaseInfo': 'Freigabeprotokoll',
    'contactInquiries.statTotal': 'Anfragen insgesamt',
    'contactInquiries.statReleased': 'Freigegeben',
    'contactInquiries.statPending': 'Freigabe ausstehend',
    'contactInquiries.statUnverified': 'Nicht verifizierte Kontakte',

    'auth.title': 'Admin-Anmeldung',
    'auth.email': 'E-Mail-Adresse',
    'auth.password': 'Passwort',
    'auth.signIn': 'Anmelden',
    'auth.forgotPassword': 'Passwort vergessen?',
    'auth.forgotDialogTitle': 'Passwort zurücksetzen',
    'auth.forgotStepEmail': 'Geben Sie die E-Mail Ihres Kontos ein. Wir senden einen Einmalcode an diese Adresse.',
    'auth.forgotStepReset': 'Geben Sie den Code aus der E-Mail ein und wählen Sie ein neues Passwort.',
    'auth.sendOtp': 'Code senden',
    'auth.otpSent': 'Falls ein Konto mit dieser E-Mail existiert, wurde ein Code gesendet. Bitte Posteingang prüfen.',
    'auth.otp': 'Einmalcode',
    'auth.newPassword': 'Neues Passwort',
    'auth.confirmNewPassword': 'Neues Passwort bestätigen',
    'auth.resetPassword': 'Passwort zurücksetzen',
    'auth.backToEmailStep': 'Andere E-Mail verwenden',
    'auth.passwordMismatch': 'Neues Passwort und Bestätigung stimmen nicht überein.',
    'auth.resetSuccess': 'Ihr Passwort wurde zurückgesetzt. Sie können sich jetzt anmelden.',
    'auth.resetFailed': 'Passwort konnte nicht zurückgesetzt werden. Bitte erneut versuchen.',
    'auth.invalidEmail': 'Bitte eine gültige E-Mail-Adresse eingeben.',
    'auth.loginFailed': 'Anmeldung fehlgeschlagen',
    'auth.loginFailedRetry': 'Anmeldung fehlgeschlagen. Bitte erneut versuchen.',
    'auth.captchaLabel': 'Sicherheitsprüfung',
    'auth.enterCaptcha': 'Sicherheitscode',
    'auth.refreshCaptcha': 'Captcha aktualisieren',
    'auth.captchaRequired': 'Bitte geben Sie den Sicherheitscode ein.',
    'auth.captchaInvalid': 'Ungültiger Sicherheitscode. Bitte erneut versuchen.',
    'common.adminUser': 'Administrator',
    'dashboard.title': 'Übersicht',
    'dashboard.platformUserVisitsTitle': 'Android & iOS Benutzerbesuche',
    'dashboard.platformUserVisitsSubtitle': 'Aufschlüsselung des Plattform-Traffics nach Zeitraum',
    'dashboard.moduleHealthTitle': 'Modul-Status & Volumen-Vergleich',
    'dashboard.moduleHealthSubtitle': 'Echtzeit-Entitätszahlen & Betriebsstatus über Systemmodule',
    'dashboard.totalRecords': 'Datensätze gesamt',
    'dashboard.activeEntities': 'Genehmigte Entitäten',
    'dashboard.pendingApprovals': 'Ausstehende Genehmigungen',
    'dashboard.totalVolume': 'Gesamtvolumen',
    'dashboard.activeRate': 'Aktivitätsquote',
    'nav.accommodations': 'Unterkünfte',
    'dashboard.welcome': 'Willkommen zurück! Hier ist Ihre Admin-Übersicht',
    'dashboard.downloadReport': 'Bericht herunterladen',
    'dashboard.statUser': 'Benutzerstatistik',
    'dashboard.statCity': 'Städte-Statistik',
    'dashboard.statEvent': 'Veranstaltungsstatistik',
    'dashboard.statPromotion': 'Aktionsstatistik',
    'dashboard.statContact': 'Kontaktstatistik',
    'dashboard.statAccommodation': 'Unterkunftsstatistik',
    'dashboard.total': 'Gesamt',
    'dashboard.active': 'Aktiv',
    'dashboard.newThisMonth': 'Neu diesen Monat',
    'dashboard.pending': 'Ausstehend',
    'dashboard.monthlyChange': 'Monatliche Änderung',
    'dashboard.current': 'Aktuell',
    'dashboard.last': 'Vorher',
    'dashboard.recentActivity': 'Letzte Aktivität',
    'dashboard.noRecentActivity': 'Keine aktuelle Aktivität.',
    'dashboard.categoryBreakdown': 'Kategorieverteilung',
    'dashboard.noData': 'Keine Daten verfügbar.',
    'dashboard.activityOverview': 'Aktivitätsübersicht',
    'dashboard.viewTimeline': 'Zeitachse anzeigen',
    'dashboard.newUsers': 'Neue Benutzer',
    'dashboard.activeEvents': 'Aktive Veranstaltungen',
    'dashboard.recentApprovals': 'Letzte Freigaben',
    'dashboard.pendingApproval': 'Genehmigung ausstehend',
    'dashboard.msgEventsPending': 'Veranstaltungen',
    'dashboard.msgPromotionsPending': 'Aktionen',
    'dashboard.msgContactsPending': 'Kontakte',
    'dashboard.msgAccommodationsPending': 'Unterkünfte',
    'dashboard.quickActions': 'Schnellaktionen',
    'dashboard.quickActionsSub': 'Häufige Aufgaben',
    'dashboard.activeUsers': 'Aktive Benutzer',
    'dashboard.activeUsersSub': 'Derzeit online',
    'dashboard.moreOnline': 'weitere',
    'dashboard.currentUsers': 'Aktuelle Benutzer',
    'dashboard.approvalStats': 'Freigabe-Statistik',
    'dashboard.approvalStatsSub': 'Letzte 30 Tage',
    'dashboard.approved': 'Genehmigt',
    'dashboard.rejected': 'Abgelehnt',
    'dashboard.cityDialogTitle': 'Städte-Statistik',
    'dashboard.selectCity': 'Stadt wählen',
    'dashboard.errorLoad': 'Dashboard-Statistiken konnten nicht geladen werden',
    'dashboard.errorLoadData': 'Fehler beim Laden der Dashboard-Daten. Bitte später erneut versuchen.',
    'dashboard.androidAppTracking': 'Android-Nutzer-Tracking',
    'dashboard.iosAppTracking': 'iOS-Nutzer-Tracking',
    'dashboard.totalAppDownloads': 'Gesamte App-Downloads',
    'dashboard.googlePlayStore': 'Google Play Store',
    'dashboard.appleAppStore': 'Apple App Store',
    'dashboard.combinedEcosystem': 'Kombiniertes mobiles Ökosystem',
    'dashboard.activeAppUsers': 'Aktive Nutzer',
    'common.city': 'Stadt',
    'common.yes': 'Ja',
    'common.no': 'Nein',
    'common.name': 'Name',
    'common.title': 'Titel',
    'common.description': 'Beschreibung',
    'common.date': 'Datum',
    'common.status': 'Status',
    'common.actions': 'Aktionen',
    'common.edit': 'Bearbeiten',
    'common.delete': 'Löschen',
    'common.superAdminOnly': 'Nur Super-Admins können diese Aktion ausführen.',
    'common.cancel': 'Abbrechen',
    'common.view': 'Ansehen',
    'common.mobileView': 'Mobile-Ansicht',
    'common.close': 'Schließen',
    'common.update': 'Aktualisieren',
    'common.create': 'Anlegen',
    'common.add': 'Hinzufügen',
    'common.search': 'Suchen',
    'common.all': 'Alle',
    'common.pleaseWait': 'Bitte warten...',
    'common.previous': 'Zurück',
    'common.next': 'Weiter',
    'common.optional': 'optional',
    'common.active': 'Aktiv',
    'common.inactive': 'Inaktiv',
    'common.unknown': 'Unbekannt',
    'common.approval': 'Freigabe',
    'common.saving': 'Speichern…',
    'common.updating': 'Aktualisieren…',
    'common.rowsPerPage': 'Zeilen pro Seite:',
    'common.note': 'Hinweis',
    'common.approve': 'Genehmigen',
    'common.decline': 'Ablehnen',
    'common.reject': 'Ablehnen',
    'common.moveToPending': 'Auf ausstehend setzen',
    'about': 'Über uns',
    'common.openingHours': 'Öffnungszeiten',
    'common.email': 'E-Mail',
    'common.phone': 'Telefon',
    'common.website': 'Webseite',
    'common.address': 'Adresse',
    'common.houseNumber': 'Hausnummer',
    'common.postalCode': 'Postleitzahl',
    'common.longitude': 'Längengrad',
    'common.latitude': 'Breitengrad',
    'common.whatsapp': 'WhatsApp',
    'common.whatsAppText': 'WhatsApp-Text',
    'common.supportLanguages': 'Unterstützte Sprachen (kommagetrennt)',
    'common.clientTypes': 'Kundentypen (kommagetrennt)',
    'common.imageUrlsComma': 'Bild-URLs (kommagetrennt)',
    'common.district': 'Bezirk',
    'common.contactClaimed': 'Kontakt beansprucht',
    'common.googleRating': 'Google-Bewertung verfügbar',
    'common.infoNote': 'Info-Hinweis',
    'common.contactPerson': 'Ansprechpartner',
    'promotions.title': 'Aktionen',
    'promotions.filterCity': 'Stadt',
    'promotions.filterStatus': 'Status',
    'promotions.allStatusesHint': 'Alle Status',
    'promotions.errFieldRequired': 'Dieses Feld ist erforderlich.',
    'promotions.errTimeRequiredShort': 'Aktionszeit ist erforderlich.',
    'promotions.errInvalidDate': 'Bitte gültiges Datum eingeben (JJJJ-MM-TT).',
    'promotions.errInvalidTime': 'Bitte gültige Uhrzeit eingeben.',
    'promotions.fieldBanner': 'Bannerbild',
    'promotions.colImage': 'Bild',
    'promotions.searchTitle': 'Nach Titel suchen',
    'promotions.add': 'Aktion hinzufügen',
    'promotions.colCity': 'Stadt',
    'promotions.colTitle': 'Titel',
    'promotions.colDescription': 'Beschreibung',
    'promotions.colDate': 'Datum',
    'promotions.colStatus': 'Status',
    'promotions.colApproval': 'Freigabe',
    'promotions.colActions': 'Aktionen',
    'promotions.notePrefix': 'Hinweis',
    'promotions.dialogEdit': 'Aktion bearbeiten',
    'promotions.dialogView': 'Aktion Details anzeigen',
    'promotions.dialogAdd': 'Neue Aktion',
    'promotions.fieldTitle': 'Aktionstitel',
    'promotions.fieldDesc': 'Beschreibung',
    'promotions.fieldImageUrls': 'Bild-URLs (kommagetrennt)',
    'promotions.fieldDiscountText': 'Rabatt-Text',
    'promotions.fieldDiscountCoupon': 'Rabattcode',
    'promotions.fieldDate': 'Aktionsdatum (JJJJ-MM-TT)',
    'promotions.fieldTime': 'Aktionszeit (HH:mm)',
    'promotions.fieldWebUrl': 'Web-URL',
    'promotions.fieldWebUrlBtn': 'Button-Text Web-URL',
    'promotions.fieldCallToAction': 'Call to Action',
    'promotions.fieldSharingUrl': 'Teilen-URL',
    'promotions.fieldTermsAndConditions': 'Allgemeine Geschaftsbedingungen',
    'promotions.fieldTargetedAudience': 'Zielgruppe',
    'promotions.targetAudienceAllUsers': 'Alle Benutzer',
    'promotions.targetAudienceStudents': 'Studenten',
    'promotions.targetAudienceFamilies': 'Familien',
    'promotions.targetAudienceWorkers': 'Arbeiter',
    'promotions.fieldWhatYouGet': 'Was Sie erhalten',
    'promotions.fieldPromotionDetails': 'Aktionsdetails',
    'promotions.fieldActive': 'Aktiv',
    'promotions.fieldApprovalStatus': 'Freigabestatus',
    'promotions.fieldApprovalNote': 'Freigabe-Hinweis',
    'promotions.approvalDialogTitle': 'Freigabestatus aktualisieren',
    'promotions.declineNote': 'Ablehnungsgrund*',
    'promotions.approvalNoteLabel': 'Freigabe-Hinweis',
    'promotions.declineNoteRequired': 'Ablehnungsgrund erforderlich',
    'promotions.placeholderDecline': 'Grund für Ablehnung…',
    'promotions.placeholderOptional': 'Optionaler Hinweis…',
    'promotions.updateStatus': 'Status aktualisieren',
    'promotions.toastFillRequired': 'Bitte alle Pflichtfelder ausfüllen',
    'promotions.toastValidDate': 'Gültiges Datum (JJJJ-MM-TT) und Zeit (HH:mm) eingeben',
    'promotions.toastUpdated': 'Aktion erfolgreich aktualisiert.',
    'promotions.toastAdded': 'Aktion erfolgreich hinzugefügt.',
    'promotions.toastSaveError': 'Fehler beim Speichern. Bitte erneut versuchen.',
    'promotions.confirmDelete': 'Diese Aktion wirklich löschen?',
    'promotions.toastDeleted': 'Aktion erfolgreich gelöscht.',
    'promotions.toastDeleteError': 'Fehler beim Löschen. Bitte erneut versuchen.',
    'promotions.toastNoteReject': 'Bei Ablehnung ist ein Freigabe-Hinweis erforderlich',
    'promotions.toastApprovalUpdated': 'Freigabestatus erfolgreich aktualisiert.',
    'promotions.toastApprovalError': 'Fehler beim Aktualisieren des Freigabestatus',
    'contacts.title': 'Kontaktverwaltung',
    'contacts.filterCity': 'Stadt filtern',
    'contacts.filterCategory': 'Kategorie filtern',
    'contacts.allCategories': 'Alle Kategorien',
    'contacts.refresh': 'Aktualisieren',
    'contacts.add': 'Kontakt hinzufügen',
    'contacts.clearFilters': 'Filter zurücksetzen',
    'contacts.colInfo': 'Info',
    'contacts.colLocation': 'Standort',
    'contacts.colContactDetails': 'Kontaktdaten',
    'contacts.colOwnerName': 'Eigentümer Name',
    'contacts.colAddedByType': 'Hinzugefügt von',
    'contacts.colApprovedByName': 'Genehmigt von',
    'contacts.colBusinessInfo': 'Geschäftsinformationen',
    'contacts.dialogEdit': 'Kontakt bearbeiten',
    'contacts.dialogAdd': 'Neuer Kontakt',
    'contacts.dialogView': 'Kontakt Details anzeigen',
    'contacts.fieldName': 'Name',
    'contacts.fieldCategory': 'Kategorie',
    'contacts.fieldInfoNote': 'Info-Hinweis',
    'contacts.fieldContactPerson': 'Ansprechpartner',
    'contacts.fieldDistrict': 'Bezirk',
    'contacts.toastNoteReject': 'Bei Ablehnung ist ein Freigabe-Hinweis erforderlich',
    'contacts.toastUpdated': 'Kontakt erfolgreich aktualisiert.',
    'contacts.toastCreated': 'Kontakt erfolgreich angelegt.',
    'contacts.toastSaveError': 'Fehler beim Speichern des Kontakts',
    'contacts.confirmDelete': 'Diesen Kontakt wirklich löschen?',
    'contacts.toastDeleted': 'Kontakt erfolgreich gelöscht.',
    'contacts.toastDeleteError': 'Fehler beim Löschen. Bitte erneut versuchen.',
    'contacts.toastFillRequired': 'Bitte alle Pflichtfelder ausfüllen',
    'contacts.errFieldRequired': 'Dieses Feld ist erforderlich.',
    'contacts.errInfoNoteRequired': 'Info-Hinweis ist erforderlich.',
    'contacts.errPostalRequired': 'Postleitzahl ist erforderlich.',
    'contacts.errEmailRequired': 'E-Mail ist erforderlich.',
    'contacts.errEmailInvalid': 'Bitte eine gültige E-Mail-Adresse eingeben.',
    'contacts.errSubCategoryRequired': 'Mindestens eine Unterkategorie auswählen.',
    'contacts.errPostalDigits5': 'Die Postleitzahl muss genau 5 Ziffern haben.',
    'contacts.errWhatsappMax20': 'WhatsApp-Nummer darf maximal 20 Zeichen haben.',
    'contacts.helperWhatsappMax20': 'Höchstens 20 Zeichen.',
    'contacts.placeholderPostal5': '5 Ziffern',
    'contacts.approvalDialogTitle': 'Kontaktstatus aktualisieren',
    'contacts.fieldRejectionNoteShort': 'Ablehnungsgrund*',
    'contacts.fieldApprovalNoteShort': 'Freigabe-Hinweis',
    'contacts.helperRejectionRequired': 'Ablehnungsgrund erforderlich',
    'contacts.toastApprovalErr': 'Fehler beim Aktualisieren des Freigabestatus',
    'contacts.toastApprovalErr2': 'Freigabestatus konnte nicht aktualisiert werden',
    'contacts.fieldOwnerName': 'Eigentümer',
    'contacts.fieldApprovedBy': 'Genehmigt von',
    'contacts.fieldSubCategories': 'Unterkategorien',
    'contacts.fieldSubCategoriesComma': 'Unterkategorien (kommagetrennt)',
    'contacts.documentsRequired': 'Erforderliche Dokumente',
    'contacts.rulesRegulations': 'AGB & Bedingungen',
    'contacts.pricingInformation': 'Preise & Tarife',
    'contacts.addPricingPlan': 'Tarif hinzufügen',
    'contacts.noPricingPlans': 'Noch keine Tarife hinzugefügt',
    'contacts.pricingDescription': 'Fügen Sie Preispakete, Abonnementstufen oder Gebühren mit Highlights und Abzeichen hinzu und verwalten Sie diese.',
    'contacts.planTitle': 'Tariftitel',
    'contacts.badgeTag': 'Abzeichen / Kennzeichnung',
    'contacts.noBadge': 'Kein Abzeichen',
    'contacts.price': 'Preis',
    'contacts.billingPeriod': 'Abrechnungszeitraum',
    'contacts.periodMonth': 'Monat',
    'contacts.periodWeek': 'Woche',
    'contacts.periodYear': 'Jahr',
    'contacts.periodOneTime': 'Einmalig',
    'contacts.hintNote': 'Hinweis / Notiz',
    'contacts.description': 'Beschreibung',
    'contacts.planHighlights': 'Tarif-Highlights & Leistungen',
    'contacts.highlightPlaceholder': 'Highlight hinzufügen und Enter drücken',
    'contacts.addHighlight': 'Hinzufügen',
    'contacts.pricingTitleRequired': 'Der Tarifname ist erforderlich',
    'contacts.pricingDescriptionRequired': 'Die Tarifbeschreibung ist erforderlich',
    'contacts.pricingPriceInvalid': 'Geben Sie einen gültigen Preis mit höchstens 6 Ziffern und 2 Dezimalstellen ein',
    'contacts.pricingTitleMax': 'Der Tarifname darf höchstens 50 Zeichen lang sein',
    'contacts.pricingDescriptionMax': 'Die Beschreibung darf höchstens 500 Zeichen lang sein',
    'contacts.pricingHintMax': 'Hinweis / Notiz darf höchstens 250 Zeichen lang sein',
    'contacts.pricingFeatureMax': 'Jedes Merkmal darf höchstens 250 Zeichen lang sein',
    'contacts.pricingHeaderTitle': 'Preistitel',
    'contacts.pricingHeaderDescription': 'Preisbeschreibung',
    'contacts.pricingHeaderTitleMax': 'Die Preisüberschrift darf höchstens 50 Zeichen lang sein',
    'contacts.pricingHeaderDescriptionMax': 'Die Beschreibung der Preisüberschrift darf höchstens 150 Zeichen lang sein',
    'contacts.pricingPlan': 'Tarif',
    'contacts.addItem': 'Eintrag hinzufügen',
    'contacts.noItemsAdded': 'Noch keine Einträge hinzugefügt. Klicken Sie auf "Eintrag hinzufügen", um einen hinzuzufügen.',
    'contacts.charLimitExceeded': 'Zeichenlimit überschritten:',
    'accommodation.title': 'Unterkunft',
    'accommodation.add': 'Unterkunft hinzufügen',
    'accommodation.selectCity': 'Stadt wählen',
    'accommodation.searchPlaceholder': 'Unterkünfte suchen…',
    'accommodation.colLocation': 'Standortdetails',
    'accommodation.colContact': 'Kontakt',
    'accommodation.colFinancial': 'Finanzen',
    'accommodation.colAvailability': 'Verfügbarkeit',
    'accommodation.colFacilities': 'Ausstattung',
    'accommodation.dialogEdit': 'Unterkunft bearbeiten',
    'accommodation.dialogAdd': 'Neue Unterkunft',
    'accommodation.dialogView': 'Unterkunft Details anzeigen',
    'accommodation.fieldWhatsApp': 'WhatsApp-Nummer',
    'accommodation.fieldRent': 'Miete',
    'accommodation.fieldDeposit': 'Kaution',
    'accommodation.fieldAvailableFrom': 'Verfügbar ab',
    'accommodation.fieldOwner': 'Eigentümer',
    'accommodation.fieldFacilities': 'Ausstattung',
    'accommodation.fieldWhatYouGet': 'Was Sie erhalten',
    'accommodation.fieldImageUrls': 'Bild-URLs',
    'accommodation.fieldApprovalNote': 'Freigabe-Hinweis',
    'accommodation.fieldEnabled': 'Aktiviert',
    'accommodation.approveTitle': 'Genehmigen',
    'accommodation.rejectTitle': 'Ablehnen',
    'accommodation.resetTitle': 'Zurücksetzen',
    'accommodation.approveAccommodation': 'Unterkunft',
    'accommodation.fieldRejectionNote': 'Ablehnungsgrund*',
    'accommodation.helperRejectNote': 'Hinweis bei Ablehnung erforderlich',
    'accommodation.placeholderReject': 'Grund für Ablehnung…',
    'accommodation.placeholderOptional': 'Optionaler Hinweis…',
    'accommodation.confirmDelete': 'Diese Unterkunft wirklich löschen?',
    'accommodation.toastDeleted': 'Unterkunft erfolgreich gelöscht.',
    'accommodation.toastFillRequired': 'Bitte alle Pflichtfelder ausfüllen.',
    'accommodation.toastFixFieldErrors': 'Bitte ungültige Felder korrigieren, bevor Sie speichern.',
    'accommodation.toastUpdateError': 'Fehler beim Aktualisieren der Unterkunft. Bitte erneut versuchen.',
    'accommodation.toastDeleteError': 'Fehler beim Löschen. Bitte erneut versuchen.',
    'accommodation.toastEmail': 'Bitte gültige E-Mail-Adresse eingeben',
    'accommodation.toastRent': 'Bitte gültige Miete eingeben (≥ 0)',
    'accommodation.toastDeposit': 'Bitte gültige Kaution eingeben (≥ 0)',
    'accommodation.toastPostalLen': 'Postleitzahl: 3–10 Zeichen',
    'accommodation.toastPostalNum': 'Postleitzahl nur Ziffern',
    'accommodation.toastLatRequired': 'Breitengrad erforderlich',
    'accommodation.toastLatRange': 'Breitengrad zwischen -90 und 90',
    'accommodation.toastLngRequired': 'Längengrad erforderlich',
    'accommodation.toastLngRange': 'Längengrad zwischen -180 und 180',
    'accommodation.toastUpdated': 'Unterkunft erfolgreich aktualisiert.',
    'accommodation.toastCreated': 'Unterkunft erfolgreich angelegt.',
    'accommodation.toastSaveError': 'Fehler beim Speichern der Unterkunft',
    'accommodation.toastApprovalOk': 'Status der Unterkunft erfolgreich aktualisiert.',
    'accommodation.isActiveLabel': 'Aktiv',
    'accommodation.isEnabledLabel': 'Aktiviert',
    'accommodation.ownerPrefix': 'Eigentümer',
    'accommodation.depositLabel': 'Kaution',
    'accommodation.toastApprovalErr': 'Fehler beim Aktualisieren des Freigabestatus',
    'accommodation.autoFillTitle': 'Automatisch aus Text ausfüllen',
    'accommodation.autoFillSubtitle': 'Anzeigentext einfügen & Automatisch ausfüllen klicken',
    'accommodation.autoFillPlaceholder': 'Rohtext der Unterkunft einfügen (z. B. Titel, Miete 500 €, Kaution 1000 €, Adresse, Stadt, Telefon, E-Mail, Ausstattung)...',
    'accommodation.btnAutoFill': 'Automatisch aus Text ausfüllen',
    'accommodation.toastAutoFillOk': 'Unterkunftsdetails erfolgreich automatisch ausgefüllt!',
    'accommodation.toastAutoFillNoMatch': 'Keine passenden Unterkunftsdetails im Text gefunden.',
    'facilities.title': 'Ausstattung Unterkunft',
    'facilities.add': 'Ausstattung hinzufügen',
    'facilities.searchPlaceholder': 'Ausstattung suchen…',
    'facilities.colEnglish': 'Titel (Englisch)',
    'facilities.colGerman': 'Titel (Deutsch)',
    'facilities.empty': 'Keine Einträge gefunden.',
    'facilities.dialogEdit': 'Ausstattung bearbeiten',
    'facilities.dialogAdd': 'Neue Ausstattung',
    'facilities.fieldTitleEn': 'Titel (Englisch)',
    'facilities.fieldTitleDe': 'Titel (Deutsch)',
    'facilities.toastFill': 'Bitte alle Pflichtfelder ausfüllen',
    'facilities.toastUpdated': 'Ausstattung erfolgreich aktualisiert.',
    'facilities.toastCreated': 'Ausstattung erfolgreich angelegt.',
    'facilities.toastSaveError': 'Fehler beim Speichern. Bitte erneut versuchen.',
    'facilities.confirmDelete': 'Diese Ausstattung wirklich löschen?',
    'facilities.toastDeleted': 'Ausstattung erfolgreich gelöscht.',
    'facilities.toastDeleteError': 'Fehler beim Löschen. Bitte erneut versuchen.',
    'accTypes.title': 'Unterkunftsart',
    'accTypes.add': 'Unterkunftsart hinzufügen',
    'accTypes.colId': 'ID',
    'accTypes.colName': 'Name',
    'accTypes.colTranslations': 'Übersetzungen',
    'accTypes.empty': 'Keine Unterkunftsarten gefunden.',
    'accTypes.dialogEdit': 'Unterkunftsart bearbeiten',
    'accTypes.dialogAdd': 'Unterkunftsart hinzufügen',
    'accTypes.fieldNamePh': 'z. B. Wohnung',
    'accTypes.translationsHint': 'Übersetzungen (alle Felder Pflicht)',
    'accTypes.fieldLanguage': 'Sprache',
    'accTypes.namePlaceholder': 'Übersetzter Name',
    'accTypes.addTranslation': 'Übersetzung hinzufügen',
    'accTypes.toastNameRequired': 'Name ist erforderlich.',
    'accTypes.toastLangRequired': 'Sprachcode ist erforderlich.',
    'accTypes.toastTransNameRequired': 'Name ist erforderlich.',
    'accTypes.translationPrefix': 'Übersetzung ',
    'accTypes.translationLangRequired': 'Übersetzung {n}: Sprachcode ist erforderlich.',
    'accTypes.translationNameRequired': 'Übersetzung {n}: Name ist erforderlich.',
    'accTypes.updated': 'Unterkunftsart erfolgreich aktualisiert.',
    'accTypes.created': 'Unterkunftsart erfolgreich angelegt.',
    'accTypes.saveError': 'Fehler beim Speichern. Bitte erneut versuchen.',
    'accTypes.confirmDelete': 'Diese Unterkunftsart wirklich löschen?',
    'accTypes.deleted': 'Unterkunftsart erfolgreich gelöscht.',
    'accTypes.deleteError': 'Fehler beim Löschen. Bitte erneut versuchen.',
    'common.clear': 'Zurücksetzen',
    'common.enabled': 'Aktiviert',
    'common.none': 'Keine',
    'common.free': 'Kostenlos',
    'common.save': 'Speichern',
    'common.preview': 'Vorschau',
    'common.urlInvalid': 'Bitte eine gültige URL eingeben (z. B. https://example.com)',
    'common.filterClear': 'Filter zurücksetzen',
    'common.searchByName': 'Nach Name suchen',
    'common.searchByCode': 'Nach Code suchen',
    'common.isEnabled': 'Aktiviert',
    'common.id': 'ID',
    'common.translations': 'Übersetzungen',
    'common.language': 'Sprache',
    'common.translationsRequired': 'Übersetzungen (alle Felder Pflicht)',
    'common.translatedNamePh': 'Übersetzter Name',
    'common.addTranslation': 'Übersetzung hinzufügen',
    'common.visitWebsite': 'Website besuchen',
    'common.sharePrefix': 'Teilen:',
    'events.searchTitle': 'Nach Titel suchen',
    'events.title': 'Veranstaltungen',
    'events.dialogEdit': 'Veranstaltung bearbeiten',
    'events.dialogAdd': 'Neue Veranstaltung',
    'events.dialogView': 'Veranstaltungsdetails anzeigen',
    'events.addEvent': 'Veranstaltung hinzufügen',
    'events.colDescription': 'Beschreibung',
    'events.colLocation': 'Ort',
    'events.colDateTime': 'Datum & Uhrzeit',
    'events.colCharges': 'Gebühren',
    'events.colUrls': 'URLs',
    'events.fieldEventTitle': 'Veranstaltungstitel',
    'events.fieldCharges': 'Gebühren',
    'events.fieldEventDate': 'Datum',
    'events.fieldEventTime': 'Uhrzeit',
    'events.fieldWebUrlBtn': 'Button-Text Web-URL',
    'events.approvalDialogTitle': 'Veranstaltungsstatus aktualisieren',
    'events.toastDeclineNote': 'Beim Ablehnen ist ein Freigabe-Hinweis erforderlich',
    'events.toastStatusOk': 'Veranstaltungsstatus erfolgreich aktualisiert.',
    'events.toastApprovalErrPrefix': 'Fehler beim Aktualisieren des Freigabestatus',
    'events.errLatRequired': 'Breitengrad erforderlich',
    'events.errLatNum': 'Breitengrad muss eine gültige Zahl sein',
    'events.errLatRange': 'Breitengrad muss zwischen -90 und 90 liegen',
    'events.errLngRequired': 'Längengrad erforderlich',
    'events.errLngNum': 'Längengrad muss eine gültige Zahl sein',
    'events.errLngRange': 'Längengrad muss zwischen -180 und 180 liegen',
    'events.errTitleRequired': 'Titel ist erforderlich.',
    'events.errDescriptionRequired': 'Beschreibung ist erforderlich.',
    'events.errCityRequired': 'Stadt ist erforderlich.',
    'events.errAddressRequired': 'Adresse ist erforderlich.',
    'events.errPostalRequired': 'Postleitzahl ist erforderlich.',
    'events.errPostalFiveDigits': 'Die Postleitzahl muss genau 5 Ziffern haben.',
    'events.errEventDateRequired': 'Datum ist erforderlich.',
    'events.errEventTimeRequired': 'Uhrzeit ist erforderlich.',
    'events.errChargesRequired': 'Gebühren sind erforderlich.',
    'events.errChargesNum': 'Gebühren müssen eine gültige Zahl sein.',
    'events.errChargesMin': 'Gebühren können nicht negativ sein.',
    'events.errChargesMax': 'Gebühren dürfen 10.000 nicht überschreiten.',
    'events.errChargesMaxLen': 'Gebühren dürfen maximal 6 Zeichen lang sein.',
    'events.helperLngRange': 'Zwischen -180 und 180',
    'events.helperLatRange': 'Zwischen -90 und 90',
    'events.toastInvalidUrls': 'Bitte ungültige URLs korrigieren',
    'events.toastUpdated': 'Veranstaltung erfolgreich aktualisiert.',
    'events.toastCreated': 'Veranstaltung erfolgreich angelegt.',
    'events.toastSaveError': 'Fehler beim Speichern der Veranstaltung. Bitte erneut versuchen.',
    'events.confirmDelete': 'Diese Veranstaltung wirklich löschen?',
    'events.toastDeleted': 'Veranstaltung erfolgreich gelöscht.',
    'events.toastDeleteError': 'Fehler beim Löschen der Veranstaltung.',
    'events.toastFetchError': 'Fehler beim Abrufen der Veranstaltungsdetails',
    'eventTypes.title': 'Veranstaltungstyp',
    'eventTypes.add': 'Veranstaltungstyp hinzufügen',
    'eventTypes.empty': 'Keine Veranstaltungstypen gefunden.',
    'eventTypes.dialogEdit': 'Veranstaltungstyp bearbeiten',
    'eventTypes.dialogAdd': 'Veranstaltungstyp hinzufügen',
    'eventTypes.fieldNamePh': 'z. B. Konferenz (als Englisch genutzt)',
    'eventTypes.updated': 'Veranstaltungstyp erfolgreich aktualisiert.',
    'eventTypes.created': 'Veranstaltungstyp erfolgreich angelegt.',
    'eventTypes.confirmDelete': 'Diesen Veranstaltungstyp wirklich löschen?',
    'eventTypes.deleted': 'Veranstaltungstyp erfolgreich gelöscht.',
    'promoTypes.title': 'Aktionstyp',
    'promoTypes.add': 'Aktionstyp hinzufügen',
    'promoTypes.empty': 'Keine Aktionstypen gefunden.',
    'promoTypes.dialogEdit': 'Aktionstyp bearbeiten',
    'promoTypes.dialogAdd': 'Aktionstyp hinzufügen',
    'promoTypes.fieldNamePh': 'z. B. Saisonangebot (als Englisch genutzt)',
    'promoTypes.updated': 'Aktionstyp erfolgreich aktualisiert.',
    'promoTypes.created': 'Aktionstyp erfolgreich angelegt.',
    'promoTypes.confirmDelete': 'Diesen Aktionstyp wirklich löschen?',
    'promoTypes.deleted': 'Aktionstyp erfolgreich gelöscht.',
    'serviceSub.title': 'Service-Unterkategorien',
    'serviceSub.filterCategory': 'Nach Kategorie filtern',
    'serviceSub.searchPlaceholder': 'Unterkategorien suchen…',
    'serviceSub.add': 'Unterkategorie hinzufügen',
    'serviceSub.colEnglish': 'Name (Englisch)',
    'serviceSub.colGerman': 'Name (Deutsch)',
    'serviceSub.colEnabled': 'Aktiviert',
    'serviceSub.empty': 'Keine Service-Unterkategorien gefunden.',
    'serviceSub.dialogEdit': 'Unterkategorie bearbeiten',
    'serviceSub.dialogAdd': 'Neue Unterkategorie',
    'serviceSub.nameEn': 'Name (Englisch)',
    'serviceSub.nameDe': 'Name (Deutsch)',
    'serviceSub.fieldCategory': 'Kategorie',
    'serviceSub.toastFill': 'Bitte alle Pflichtfelder ausfüllen',
    'serviceSub.toastUpdated': 'Unterkategorie erfolgreich aktualisiert.',
    'serviceSub.toastCreated': 'Unterkategorie erfolgreich angelegt.',
    'serviceSub.toastSaveError': 'Fehler beim Speichern der Unterkategorie',
    'serviceSub.confirmDelete': 'Diese Unterkategorie wirklich löschen?',
    'serviceSub.toastDeleted': 'Unterkategorie erfolgreich gelöscht.',
    'serviceSub.toastDeleteError': 'Fehler beim Löschen der Unterkategorie',
    'cities.pageTitle': 'Städte',
    'cities.addNew': 'Neue Stadt',
    'cities.colImage': 'Bild',
    'cities.colCityCode': 'Stadtkürzel',
    'cities.colIsEnabled': 'Aktiviert',
    'cities.dialogEdit': 'Stadt bearbeiten',
    'cities.dialogAdd': 'Neue Stadt',
    'cities.fieldCityName': 'Stadtname',
    'cities.fieldCityCode': 'Stadtkürzel',
    'cities.fieldImageUrl': 'Bild-URL',
    'cities.toastUpdated': 'Stadt erfolgreich aktualisiert.',
    'cities.toastCreated': 'Stadt erfolgreich angelegt.',
    'cities.toastSaveError': 'Fehler beim Speichern der Stadt.',
    'cities.confirmDelete': 'Diese Stadt wirklich löschen?',
    'cities.toastDeleted': 'Stadt erfolgreich gelöscht.',
    'cities.toastDeleteError': 'Fehler beim Löschen der Stadt.',
    'districts.title': 'Bezirke',
    'districts.filterCity': 'Nach Stadt filtern',
    'districts.searchPlaceholder': 'Bezirke suchen…',
    'districts.add': 'Bezirk hinzufügen',
    'districts.dialogEdit': 'Bezirk bearbeiten',
    'districts.dialogAdd': 'Neuer Bezirk',
    'districts.fieldDistrictName': 'Bezirksname',
    'districts.toastUpdated': 'Bezirk erfolgreich aktualisiert.',
    'districts.toastCreated': 'Bezirk erfolgreich angelegt.',
    'districts.toastSaveError': 'Fehler beim Speichern des Bezirks.',
    'districts.confirmDelete': 'Diesen Bezirk wirklich löschen?',
    'districts.toastDeleted': 'Bezirk erfolgreich gelöscht.',
    'districts.toastDeleteError': 'Fehler beim Löschen des Bezirks.',
    'categoriesPage.title': 'Kategorien',
    'categoriesPage.searchPh': 'Kategorien suchen…',
    'categoriesPage.add': 'Kategorie hinzufügen',
    'categoriesPage.colTitle': 'Titel (EN/DE)',
    'categoriesPage.colDesc': 'Beschreibung (EN/DE)',
    'categoriesPage.colColors': 'Farben',
    'categoriesPage.colIcon': 'Symbol',
    'categoriesPage.colContact': 'Kontakt',
    'categoriesPage.colContactInfo': 'Kontaktinformation',
    'categoriesPage.colContactInfoDetails': 'Kontakt-Details',
    'categoriesPage.infoIconPrefix': 'Info-Symbol verfügbar',
    'categoriesPage.hasPrefix': 'Hat',
    'categoriesPage.emergencyPrefix': 'Notfall',
    'categoriesPage.noDocuments': 'Keine Dokumente',
    'categoriesPage.noRecommendations': 'Keine Empfehlungen',
    'categoriesPage.recCount': '{n} Empfehlung(en)',
    'categoriesPage.more': '+{n} weitere',
    'categoriesPage.moreDetails': '+{n} weitere Details',
    'categoriesPage.noData': 'Keine Daten',
    'categoriesPage.noDetails': 'Keine Details',
    'categoriesPage.manageInfo': 'Kontaktinformation verwalten',
    'categoriesPage.addInfo': 'Kontaktinformation hinzufügen',
    'categoriesPage.manageDetails': 'Kontakt-Details verwalten',
    'categoriesPage.addDetails': 'Kontakt-Details hinzufügen',
    'categoriesPage.recommended': 'Empfohlen',
    'categoriesPage.detailCount': '{n} Detail(s)',
    'categoriesPage.dialogEdit': 'Kategorie bearbeiten',
    'categoriesPage.dialogAdd': 'Neue Kategorie',
    'categoriesPage.fieldTitleEn': 'Titel (Englisch)',
    'categoriesPage.fieldTitleDe': 'Titel (Deutsch)',
    'categoriesPage.fieldDescEn': 'Beschreibung (Englisch)',
    'categoriesPage.fieldDescDe': 'Beschreibung (Deutsch)',
    'categoriesPage.fieldBg': 'Hintergrundfarbe',
    'categoriesPage.fieldImgBg': 'Bild-Hintergrundfarbe',
    'categoriesPage.fieldIcon': 'Symbol',
    'categoriesPage.switchInfoIcon': 'Info-Symbol verfügbar',
    'categoriesPage.switchHasContact': 'Hat Kontakt',
    'categoriesPage.switchEmergency': 'Notfallkontakt',
    'categoriesPage.switchCategoryFor': 'Aktiv',
    'categoriesPage.toastUpdated': 'Kategorie erfolgreich aktualisiert.',
    'categoriesPage.toastCreated': 'Kategorie erfolgreich angelegt.',
    'categoriesPage.toastSaveError': 'Fehler beim Speichern der Kategorie.',
    'categoriesPage.confirmDelete': 'Diese Kategorie wirklich löschen?',
    'categoriesPage.toastDeleted': 'Kategorie erfolgreich gelöscht.',
    'categoriesPage.toastDeleteError': 'Fehler beim Löschen der Kategorie.',
    'cinfo.title': 'Kontaktinformation',
    'cinfo.selectCategory': 'Kategorie wählen',
    'cinfo.chooseCategory': '— Kategorie wählen —',
    'cinfo.categoryNum': 'Kategorie #{n}',
    'cinfo.refresh': 'Aktualisieren',
    'cinfo.add': 'Kontaktinformation hinzufügen',
    'cinfo.selectPrompt': 'Wählen Sie eine Kategorie, um die Kontaktinformation anzuzeigen.',
    'cinfo.colContactTitle': 'Kontakttitel',
    'cinfo.colDocTitle': 'Dokumenttitel',
    'cinfo.colInfoName': 'Info-Name',
    'cinfo.colInfoTitle': 'Info-Titel',
    'cinfo.colDocValues': 'Dokumentwerte',
    'cinfo.colRecTitle': 'Empfehlungstitel',
    'cinfo.colRecValues': 'Empf.-Werte',
    'cinfo.colEnabled': 'Aktiviert',
    'cinfo.emptyFor': 'Keine Kontaktinformation für {name}.',
    'cinfo.dialogEdit': 'Kontaktinformation bearbeiten',
    'cinfo.dialogAdd': 'Kontaktinformation hinzufügen',
    'cinfo.fieldCategoryReq': 'Kategorie *',
    'cinfo.fieldContactTitleReq': 'Kontakttitel *',
    'cinfo.fieldDocTitle': 'Dokumenttitel',
    'cinfo.fieldInfoNameReq': 'Info-Name *',
    'cinfo.fieldInfoTitle': 'Info-Titel',
    'cinfo.sectionBasic': 'Grundinformationen',
    'cinfo.sectionDocuments': 'Dokumente',
    'cinfo.sectionRecommendations': 'Empfehlungen',
    'cinfo.translationEmpty': '(noch kein Titel)',
    'cinfo.docValuesTitle': 'Dokumenttitel-Werte',
    'cinfo.docValuesHint': 'Titel und Beschreibung eingeben, dann + klicken oder Enter',
    'cinfo.fieldRecTitle': 'Empfehlungstitel',
    'cinfo.recValuesTitle': 'Empfehlungswerte',
    'cinfo.recValuesHint': 'Wert eingeben und Enter oder + zum Hinzufügen',
    'cinfo.fieldEnabled': 'Aktiviert',
    'cinfo.translationsTitle': 'Übersetzungen',
    'cinfo.addTranslation': 'Übersetzung hinzufügen',
    'cinfo.loadFailed': 'Kontaktinformation konnte nicht geladen werden.',
    'cinfo.errContactTitle': 'Kontakttitel ist erforderlich',
    'cinfo.errInfoName': 'Info-Name ist erforderlich',
    'cinfo.errCategory': 'Bitte eine gültige Kategorie wählen.',
    'cinfo.toastSaved': 'Kontaktinformation erfolgreich {action}.',
    'cinfo.actionUpdated': 'aktualisiert',
    'cinfo.actionCreated': 'angelegt',
    'cinfo.confirmDelete': 'Diese Kontaktinformation löschen?',
    'cinfo.deleted': 'Erfolgreich gelöscht.',
    'cinfo.confirmDeleteTrans': 'Übersetzung für {code} löschen?',
    'cinfo.transDeleted': 'Übersetzung gelöscht.',
    'cinfo.saveError': 'Fehler beim Speichern.',
    'cinfo.deleteError': 'Fehler beim Löschen.',
    'cinfo.deleteTransError': 'Fehler beim Löschen der Übersetzung.',
    'cidetail.title': 'Kontakt-Details',
    'cidetail.addDetail': 'Detail hinzufügen',
    'cidetail.selectPrompt': 'Kategorie wählen, um Kontakt-Details anzuzeigen.',
    'cidetail.colInfoNote': 'Info-Hinweis',
    'cidetail.colRecommended': 'Empfohlen',
    'cidetail.colSubDetails': 'Unter-Details',
    'cidetail.emptyFor': 'Keine Details für {name}.',
    'cidetail.dialogEdit': 'Kontakt-Detail bearbeiten',
    'cidetail.dialogAdd': 'Kontakt-Detail hinzufügen',
    'cidetail.subItemsTitle': 'Kontakt-Details (Unterpunkte)',
    'cidetail.addSubItem': 'Unterpunkt hinzufügen',
    'cidetail.translations': 'Übersetzungen',
    'cidetail.addTranslation': 'Übersetzung hinzufügen',
    'cidetail.noTranslationsYet': 'Noch keine weiteren Sprachen. „Übersetzung hinzufügen“ für DE usw.',
    'cidetail.loadWarn': 'Detail konnte nicht geladen werden. Listen-Daten werden verwendet.',
    'cidetail.errCategory': 'Kategorie ist erforderlich',
    'cidetail.errName': 'Name ist erforderlich',
    'cidetail.errDescription': 'Beschreibung ist erforderlich',
    'cidetail.toastSaved': 'Detail erfolgreich {action}.',
    'cidetail.confirmDelete': 'Dieses Kontakt-Detail löschen? Alle Übersetzungen werden entfernt.',
    'cidetail.missingDelete': 'Id oder CategoryId zum Löschen fehlt.',
    'cidetail.deleted': 'Detail erfolgreich gelöscht.',
    'docsVerify.title': 'Dokumentenprüfung',
    'docsVerify.searchLabel': 'Suche',
    'docsVerify.searchPh': 'Suche nach Name, E-Mail, Telefon, Compliance oder Dokumentanzahl',
    'docsVerify.colDocType': 'Dokumenttyp',
    'docsVerify.colDocUrl': 'Dokument-URL',
    'docsVerify.colAction': 'Aktion',
    'docsVerify.empty': 'Keine ausstehenden Dokumente zur Prüfung.',
    'docsVerify.viewDoc': 'Dokument anzeigen',
    'docsVerify.review': 'Prüfen',
    'docsVerify.reviewTitle': 'Prüfung',
    'docsVerify.statusPending': 'AUSSTEHEND',
    'docsVerify.loadFailed': 'Dokumente konnten nicht geladen werden.',
    'docsVerify.errApprovedNotes': 'Bitte Prüfungsnotizen für GENEHMIGT eingeben.',
    'docsVerify.errRejectedReason': 'Bitte Ablehnungsgrund für ABGELEHNT eingeben.',
    'docsVerify.markedAs': 'Dokument als {status} markiert.',
    'docsVerify.reviewFailed': 'Prüfung konnte nicht gesendet werden.',
    'docsVerify.fieldReviewNotes': 'Prüfungsnotizen',
    'docsVerify.fieldRejectionReason': 'Ablehnungsgrund',
    'docsVerify.statusInReview': 'IN_REVIEW (Ausstehend)',
    'docsVerify.statusApproved': 'GENEHMIGT',
    'docsVerify.statusRejected': 'ABGELEHNT',
    'docsVerify.submitReview': 'Prüfung senden',
    'docsVerify.submitting': 'Wird gesendet…',
    'docsVerify.previewTitle': 'Dokumentvorschau',
    'docsVerify.noImage': 'Kein Bild verfügbar.',
    'docsVerify.colPhone': 'Telefon',
    'docsVerify.colDocCount': 'Dokumente',
    'docsVerify.colCompliance': 'Compliance geprüft',
    'docsVerify.colPendingDocs': 'Ausstehend',
    'docsVerify.complianceYes': 'Ja',
    'docsVerify.complianceNo': 'Nein',
    'docsVerify.openDocuments': 'Dokumente öffnen',
    'docsVerify.userDocsTitle': 'Benutzerdokumente',
    'docsVerify.documentsList': 'Dokumente',
    'docsVerify.reviewed': 'Erledigt',
    'docsVerify.markCompliance': 'Compliance als erledigt markieren',
    'docsVerify.complianceHint': 'Genehmigen Sie alle Dokumente dieses Nutzers; danach können Sie die Compliance setzen (oder es wird automatisch angeboten).',
    'docsVerify.complianceOk': 'Compliance für diesen Nutzer als erledigt markiert.',
    'docsVerify.complianceFailed': 'Compliance-Status konnte nicht aktualisiert werden.',
    'docsVerify.complianceNeedAllApproved': 'Alle Dokumente müssen genehmigt sein, bevor die Compliance gesetzt werden kann.',
    'docsVerify.allApprovedClose': 'Alle Dokumente sind genehmigt und die Compliance ist bereits gesetzt. Dialog geschlossen.',
    'docsVerify.reviewSelected': 'Auswahl prüfen',
    'docsVerify.bulkMarkedAs': 'Dokumente gesammelt als {status} markiert.',
    'docsVerify.bulkReviewTitle': 'Massenprüfung',
    'docsVerify.bulkReviewDesc': '{n} ausgewählte Dokumente prüfen.',
    'users.title': 'Benutzer',
    'users.searchPh': 'Benutzer suchen…',
    'users.add': 'Benutzer hinzufügen',
    'users.colName': 'Name',
    'users.colRole': 'Rolle',
    'users.verified': 'Verifiziert',
    'users.unverified': 'Nicht verifiziert',
    'users.blocked': 'Gesperrt',
    'users.dialogEdit': 'Benutzer bearbeiten',
    'users.dialogAdd': 'Neuer Benutzer',
    'users.fieldFirstName': 'Vorname',
    'users.fieldLastName': 'Nachname',
    'users.fieldPassword': 'Passwort',
    'users.switchEmailVerified': 'E-Mail verifiziert',
    'users.switchBlocked': 'Gesperrt',
    'users.roleUser': 'Benutzer',
    'users.roleAdmin': 'Admin',
    'users.roleAdminUser': 'Admin-Benutzer',
    'users.roleCustomer': 'Kunde',
    'users.roleSuperAdmin': 'Super-Admin',
    'users.filterRole': 'Rolle',
    'users.filterRoleAll': 'Alle Rollen',
    'users.confirmDelete': 'Diesen Benutzer wirklich löschen?',
    'users.deleteFailed': 'Benutzer konnte nicht gelöscht werden.',
    'users.deleteTitle': 'Benutzer löschen',
    'users.accountType': 'Kontoart',
    'users.accountCompany': 'Firma',
    'users.accountFreelancer': 'Freiberufler',
    'users.fullName': 'Vollständiger Name',
    'users.phoneNumber': 'Telefonnummer',
    'users.serviceType': 'Dienstleistungsart',
    'users.country': 'Land',
    'users.zipcode': 'Postleitzahl',
    'users.name': 'Name',
    'users.docProofBusinessReg': 'Nachweis der Gewerbeanmeldung / Beschäftigungserlaubnis',
    'users.docPassportPermit': 'Reisepass / Aufenthaltstitel',
    'users.companyDocs': 'Firmendokumente',
    'users.freelancerDocs': 'Freiberufler-Dokumente',
    'users.errEmailRequired': 'E-Mail ist erforderlich.',
    'users.errFirstLastRequired': 'Vorname und Nachname sind erforderlich.',
    'users.errPhoneRequired': 'Telefonnummer ist erforderlich.',
    'users.errCountryRequired': 'Land ist erforderlich.',
    'users.errFullNameRequired': 'Vollständiger Name ist erforderlich.',
    'users.errServiceTypeRequired': 'Dienstleistungsart ist erforderlich.',
    'users.errCityRequired': 'Stadt ist erforderlich.',
    'users.errDistrictRequired': 'Stadtteil ist erforderlich.',
    'users.errZipcodeRequired': 'Postleitzahl ist erforderlich.',
    'users.errNameRequired': 'Name ist erforderlich.',
    'users.errCompanyDocsRequired': 'Alle Firmendokumente sind erforderlich.',
    'users.errFreelancerDocsRequired': 'Alle Freiberufler-Dokumente sind erforderlich.',
    'users.toastUserUpdated': 'Benutzer erfolgreich aktualisiert.',
    'users.toastUserAdded': 'Benutzer erfolgreich hinzugefügt.',
    'users.errConflict409': 'Konflikt (409): Ein Benutzer mit dieser E-Mail oder Telefonnummer existiert bereits.',
    'users.errSaveFailed': 'Fehler beim Speichern des Benutzers.',
    'cityReg.title': 'Stadtanmeldung',
    'cityReg.add': 'Eintrag hinzufügen',
    'cityReg.selectCity': 'Stadt wählen',
    'cityReg.dialogEdit': 'Eintrag bearbeiten',
    'cityReg.dialogAdd': 'Neuer Eintrag',
    'cityReg.fieldUrl': 'URL',
    'cityReg.toastFill': 'Bitte alle Pflichtfelder ausfüllen',
    'cityReg.saveError': 'Fehler beim Speichern. Bitte erneut versuchen.',
    'cityReg.confirmDelete': 'Diesen Eintrag wirklich löschen?',
    'cityReg.deleteError': 'Fehler beim Löschen. Bitte erneut versuchen.',
    'support.title': 'Kundensupport',
    'support.searchPh': 'Kundensupport suchen…',
    'support.colMessage': 'Nachricht',
    'support.colCategory': 'Kategorie',
    'support.colInquirySource': 'Anfragequelle',
    'support.filterCategory': 'Kategorie',
    'support.filterCategoryAll': 'Alle Kategorien',
    'support.filterInquirySource': 'Anfragequelle',
    'support.filterInquirySourceAll': 'Alle Quellen',
    'support.fieldCategory': 'Kategorie',
    'support.fieldInquirySource': 'Anfragequelle',
    'support.inquirySourceApp': 'App',
    'support.inquirySourceCustomer': 'Kunde',
    'support.inquirySourcePlaceholder': 'App oder Kunde wählen',
    'support.colResolved': 'Gelöst',
    'support.colPending': 'Ausstehend',
    'support.updateStatusTitle': 'Status aktualisieren',
    'support.dialogEdit': 'Support bearbeiten',
    'support.dialogAdd': 'Neuer Support',
    'support.fieldMessage': 'Nachricht',
    'support.switchResolved': 'Problem gelöst',
    'support.resolveQuestion': 'Problem gelöst?',
    'support.toastFill': 'Bitte alle Pflichtfelder ausfüllen',
    'support.toastInquirySource': 'Bitte eine Anfragequelle wählen (App oder Kunde).',
    'support.toastEmail': 'Bitte eine gültige E-Mail-Adresse eingeben',
    'support.saveError': 'Fehler beim Speichern. Bitte erneut versuchen.',
    'support.confirmDelete': 'Diesen Support-Eintrag wirklich löschen?',
    'support.deleteError': 'Fehler beim Löschen. Bitte erneut versuchen.',
    'support.statusError': 'Fehler beim Aktualisieren des Status. Bitte erneut versuchen.',
    'support.tooltipStatus': 'Status aktualisieren',
    'support.colNotes': 'Notizen',
    'support.fieldNotes': 'Notizen / Anmerkungen',
    'support.toastStatusOk': 'Status erfolgreich aktualisiert.',
    'jobs.title': 'Jobportale',
    'jobs.searchPh': 'Jobportale suchen…',
    'jobs.add': 'Jobportal hinzufügen',
    'jobs.colRecommended': 'Empfohlen',
    'jobs.dialogEdit': 'Jobportal bearbeiten',
    'jobs.dialogAdd': 'Jobportal hinzufügen',
    'jobs.switchRecommended': 'Empfohlen',
    'jobs.toastFill': 'Bitte alle Pflichtfelder ausfüllen',
    'jobs.toastUpdated': 'Jobportal erfolgreich aktualisiert.',
    'jobs.toastCreated': 'Jobportal erfolgreich angelegt.',
    'jobs.toastSaveError': 'Fehler beim Speichern',
    'jobs.confirmDelete': 'Dieses Jobportal wirklich löschen?',
    'jobs.toastDeleted': 'Jobportal erfolgreich gelöscht.',
    'jobs.toastDeleteError': 'Fehler beim Löschen',
    'langSupport.title': 'Sprachunterstützung',
    'langSupport.searchPh': 'Sprachen suchen…',
    'langSupport.add': 'Sprache hinzufügen',
    'langSupport.colLangCode': 'Sprachcode',
    'langSupport.empty': 'Keine Sprachdatensätze gefunden.',
    'langSupport.dialogEdit': 'Sprache bearbeiten',
    'langSupport.dialogAdd': 'Neue Sprache',
    'langSupport.fieldLangCode': 'Sprachcode',
    'langSupport.fieldLangCodePh': 'z. B. en, de, fr',
    'langSupport.switchActive': 'Aktiv',
    'langSupport.toastUpdated': 'Sprache erfolgreich aktualisiert.',
    'langSupport.toastCreated': 'Sprache erfolgreich angelegt.',
    'langSupport.toastSaveError': 'Fehler beim Speichern der Sprache.',
    'langSupport.confirmDelete': 'Diese Sprache wirklich löschen?',
    'langSupport.toastDeleted': 'Sprache erfolgreich gelöscht.',
    'langSupport.toastDeleteError': 'Fehler beim Löschen der Sprache.',
    'cinfo.moreChip': '+{n} weitere',
    'cinfo.recValuesHint2': 'Text eingeben, dann + klicken oder Enter',
    'cinfo.fieldAddRec': 'Empfehlung hinzufügen',
    'cinfo.transContactTitle': 'Kontakttitel (Übersetzung)',
    'cinfo.transDocTitle': 'Dokumenttitel (Übersetzung)',
    'cinfo.transInfoName': 'Info-Name',
    'cinfo.transInfoTitle': 'Info-Titel',
    'cinfo.transDocValues': 'Dokumentwerte (Übersetzung)',
    'cinfo.transRecTitle': 'Empfehlungstitel (Übersetzung)',
    'cinfo.transRecValues': 'Empfehlungswerte (Übersetzung)',
    'cinfo.fieldAdd': 'Hinzufügen',
    'cinfo.removeRow': 'Entfernen',
    'cinfo.deleteTransTitle': 'Übersetzung löschen',
    'cinfo.fieldDescShort': 'Beschreib.',
    'common.remove': 'Entfernen',
    'cidetail.contactInfoSelect': 'Kontaktinformation',
    'cidetail.fieldContactInfo': 'Kontaktinformation',
    'cidetail.deleteTransServer': 'Übersetzung vom Server löschen',
    'cidetail.transName': 'Name (Übersetzung)',
    'cidetail.transDescription': 'Beschreibung (Übersetzung)',
    'cidetail.transInfoNote': 'Info-Hinweis (Übersetzung)',
    'cidetail.transSubDetails': 'Kontakt-Details (Übersetzung)',
    'cidetail.fieldNameStar': 'Name *',
    'cidetail.fieldInfoNameStar': 'Info-Name *',
    'cidetail.fieldDocumentTitle': 'Dokumenttitel',
    'cidetail.documentTitleSelect': 'Dokumenttitel wählen',
    'cidetail.documentTitleSelectContactFirst': 'Zuerst Kontaktinformation wählen',
    'cidetail.fieldDescriptionStar': 'Beschreibung *',
    'cidetail.fieldInfoNote': 'Info-Hinweis',
    'cidetail.fieldContactTitle': 'Kontakttitel',
    'cidetail.colDocumentTitle': 'Dokumenttitel',
    'cidetail.colInfoName': 'Info-Name',
    'cidetail.errContactInfo': 'Bitte Kontaktinformation wählen',
    'cidetail.noContactInfoForCategory': 'Keine Kontaktinformation für diese Kategorie. Bitte zuerst Kontaktinformation anlegen.',
    'cidetail.moreChip': '+{n} weitere',
    'cidetail.errorPrefix': 'Fehler:',
    'cidetail.unknownError': 'Unbekannter Fehler',
    'legal.title': 'Verlauf der rechtlichen Dokumente',
    'legal.subtitle': 'Verwalten Sie versionierte Datenschutzrichtlinien und Geschäftsbedingungen',
    'legal.addBtn': 'Rechtsdokumente hinzufügen',
    'legal.filterCategory': 'Kategorie filtern',
    'legal.filterPlatform': 'Plattform filtern',
    'legal.privacyPolicy': 'Datenschutzrichtlinie',
    'legal.termsConditions': 'Allgemeine Geschäftsbedingungen',
    'legal.app': 'App',
    'legal.customer': 'Kunde',
    'legal.clear': 'Löschen',
    'legal.colVersion': 'VERSION',
    'legal.colChanges': 'ÄNDERUNGEN',
    'legal.colEffectiveDate': 'INKRAFTTRETEN',
    'legal.colPlatform': 'PLATTFORM',
    'legal.colStatus': 'STATUS',
    'legal.colDocuments': 'DOKUMENTE',
    'legal.active': 'Aktiv',
    'legal.inactive': 'Inaktiv',
    'legal.view': 'Ansehen',
    'legal.dialogTitle': 'Neues rechtliches Dokument hochladen',
    'legal.category': 'Kategorie',
    'legal.platformTarget': 'Plattform-Ziel',
    'legal.versionLabel': 'Version (z.B. 1.0.0)',
    'legal.selectFile': '.html- oder .md-Datei auswählen',
    'legal.fileNamePrefix': 'Datei: ',
    'legal.changeSummary': 'Inhaltsänderung (Kurzzusammenfassung)',
    'legal.uploadSave': 'Hochladen & Speichern',
    'legal.uploading': 'Wird hochgeladen...',
    'legal.previewTitle': 'Vorschau: {category} ({platform})',
    'legal.previewPlaceholder': 'Vorschau des Dokumentinhalts wird hier angezeigt.',
    'legal.accessDenied': 'Zugriff verweigert. Nur für Super-Admins.',
    'legal.errLoad': 'Verlauf der Dokumente konnte nicht geladen werden.',
    'legal.errNoContent': 'Bitte laden Sie eine Datei hoch oder geben Sie Inhalt ein.',
    'legal.successUpload': '{category} erfolgreich hochgeladen!',
    'legal.errUpload': 'Fehler beim Hochladen des Dokuments.',
    'legal.errFetchContent': 'Inhalt des Dokuments konnte nicht abgerufen werden.',

    'events.title': 'Veranstaltungen',
    'events.addEvent': 'Veranstaltung hinzufügen',
    'events.searchTitle': 'Veranstaltungen suchen...',
    'events.trendingEvents': 'Trendige Veranstaltungen',
    'events.colEventType': 'Veranstaltungstyp',
    'events.colDescription': 'Beschreibung',
    'events.colLocation': 'Ort',
    'events.colDateTime': 'Datum & Uhrzeit',
    'events.colCharges': 'Gebühren',
    'events.colUrls': 'URLs & Medien',
    'events.expiredNotice': 'Veranstaltung abgelaufen',
    'events.dialogAdd': 'Veranstaltung hinzufügen',
    'events.dialogEdit': 'Veranstaltung bearbeiten',
    'events.dialogView': 'Veranstaltung ansehen',
    'events.fieldEventTitle': 'Veranstaltungstitel',
    'events.fieldEventType': 'Veranstaltungstyp',
    'events.errEventTypeRequired': 'Veranstaltungstyp ist erforderlich',
    'events.fieldEventDate': 'Veranstaltungsdatum',
    'events.fieldEventTime': 'Veranstaltungszeit',
    'events.fieldCharges': 'Gebühren',
    'events.fieldRecurrence': 'Wiederholung',
    'events.placeholderRecurrence': 'z. B. Täglich, Wöchentlich, Monatlich',
    'events.fieldLanguage': 'Sprache',
    'events.placeholderLanguage': 'z. B. Englisch / Deutsch',
    'events.fieldMinAge': 'Mindestalter',
    'events.placeholderMinAge': 'z. B. 18',
    'events.fieldContactPerson': 'Ansprechpartner',
    'events.fieldPersonRole': 'Rolle des Ansprechpartners',
    'events.fieldContactGender': 'Geschlecht des Ansprechpartners',
    'events.genderNone': 'Keine Angabe',
    'events.genderFemale': 'Weiblich',
    'events.genderMale': 'Männlich',
    'events.genderOther': 'Divers',
    'events.secPeopleOfEvent': 'Beteiligte Personen (DJs, MCs, Künstler usw.)',
    'events.emptyPeopleOfEvent': 'Noch keine Personen hinzugefügt.',
    'events.placeholderAddPerson': 'Personennamen hinzufügen (z. B. DJ Nova)',
    'events.btnAddPerson': 'Person hinzufügen',
    'events.secWhatYouGet': 'Inklusivleistungen / Was enthalten ist',
    'events.emptyWhatYouGet': 'Noch keine Inklusivleistungen hinzugefügt.',
    'events.placeholderAddWhatYouGet': 'Leistung hinzufügen (z. B. Begrüßungsgetränk)',
    'events.btnAddWhatYouGet': 'Leistung hinzufügen',
    'events.secCoupons': 'Gutscheine & Angebote',
    'events.offer': 'Angebot',
    'events.offers': 'Angebote',
    'events.untitledOffer': 'Unbenanntes Angebot',
    'events.tooltipEditCoupon': 'Gutschein bearbeiten',
    'events.tooltipDeleteCoupon': 'Gutschein löschen',
    'events.emptyCouponsTitle': 'Noch keine Gutscheine oder Angebote hinzugefügt.',
    'events.emptyCouponsSub': 'Füllen Sie das Formular unten aus, um ein Angebot anzuhängen.',
    'events.titleEditCoupon': '✏️ Gutscheindetails bearbeiten',
    'events.titleAddCoupon': '➕ Neuen Gutschein / neues Angebot hinzufügen',
    'events.lblCouponTitle': 'Gutscheintitel',
    'events.placeholderCouponTitle': 'z. B. Frühbucherrabatt',
    'events.lblCouponCode': 'Gutscheincode',
    'events.placeholderCouponCode': 'z. B. BEAT10',
    'events.lblCouponPrice': 'Preis / Rabatt',
    'events.placeholderCouponPrice': 'z. B. 15 EUR oder 10% Rabatt',
    'events.lblCouponUrl': 'Gutschein-URL / Link',
    'events.placeholderCouponUrl': 'https://beispiel.de/c1',
    'events.placeholderCouponDesc': 'z. B. 10% Rabatt auf den Abendkassenpreis bei Frühbuchung',
    'events.btnUpdateCoupon': 'Gutschein aktualisieren',
    'events.btnAddCoupon': 'Gutschein hinzufügen',
    'events.secBannerImage': 'Bannerbild',
    'events.fieldWebUrlBtn': 'Web-URL Button-Titel',
    'events.placeholderTerms': 'Geschäftsbedingungen eingeben...',
    'events.approvalDialogTitle': 'Genehmigungsstatus aktualisieren',
    'events.toastStatusOk': 'Genehmigungsstatus erfolgreich aktualisiert.',
    'events.toastApprovalErrPrefix': 'Genehmigungsfehler',
    'events.toastDeclineNote': 'Ablehnungsnotiz ist beim Ablehnen erforderlich',
    'events.toastUpdated': 'Veranstaltung erfolgreich aktualisiert.',
    'events.toastCreated': 'Veranstaltung erfolgreich erstellt.',
    'events.toastDeleted': 'Veranstaltung erfolgreich gelöscht.',
    'events.toastSaveError': 'Fehler beim Speichern der Veranstaltung.',
    'events.toastDeleteError': 'Fehler beim Löschen der Veranstaltung.',
    'events.confirmDelete': 'Sind Sie sicher, dass Sie diese Veranstaltung löschen möchten?',
    'events.errTitleRequired': 'Titel ist erforderlich',
    'events.errDescriptionRequired': 'Beschreibung ist erforderlich',
    'events.errCityRequired': 'Stadt ist erforderlich',
    'events.errDistrictRequired': 'Stadtteil ist erforderlich',
    'events.errAddressRequired': 'Adresse ist erforderlich',
    'events.errAddressAutoFetch': 'Bitte wählen Sie eine Adresse aus den automatischen Vorschlägen aus',
    'events.errPostalRequired': 'Postleitzahl ist erforderlich',
    'events.errPostalFiveDigits': 'Postleitzahl muss 5-stellig sein',
    'events.errEventDateRequired': 'Veranstaltungsdatum ist erforderlich',
    'events.errEventDatePast': 'Datum darf nicht in der Vergangenheit liegen',
    'events.errEventTimeRequired': 'Veranstaltungszeit ist erforderlich',
    'events.errEventTimePast': 'Die Zeit für heutige Veranstaltungen muss in der Zukunft liegen',
    'events.errLatRequired': 'Breitengrad ist erforderlich',
    'events.errLatNum': 'Breitengrad muss eine gültige Zahl sein',
    'events.errLatRange': 'Breitengrad muss zwischen -90 und 90 liegen',
    'events.errLngRequired': 'Längengrad ist erforderlich',
    'events.errLngNum': 'Längengrad muss eine gültige Zahl sein',
    'events.errLngRange': 'Längengrad muss zwischen -180 und 180 liegen',

    'userActivity.title': 'Benutzeraktivität & Engagement-Analysen',
    'userActivity.subtitle': 'Verfolgen und analysieren Sie Besucheraktivitäten.',
    'userActivity.selectModule': 'Aktivitätsmodul',
    'userActivity.refreshData': 'Daten aktualisieren',
    'userActivity.downloadXls': 'XLS-Bericht herunterladen',
    'userActivity.kpiTotalVisits': 'Gesamte Benutzerbesuche',
    'userActivity.kpiUniqueUsers': 'Eindeutige Benutzer',
    'userActivity.kpiActiveEntities': 'Aktive',
    'userActivity.kpiActiveCategories': 'Aktive Kategorien',
    'userActivity.trendChartTitle': 'Aktivitätstrend',
    'userActivity.trendChartSubtitle': 'Besuchsvolumen über den ausgewählten Zeitraum',
    'userActivity.trendNoData': 'Keine Trenddaten für diese Aktivität verfügbar.',
    'userActivity.topEntitiesTitle': 'Top',
    'userActivity.topEntitiesNoData': 'Keine Top-Aktivitätsdaten verfügbar',
    'userActivity.periodDay': 'Tag',
    'userActivity.periodWeek': 'Woche',
    'userActivity.periodMonth': 'Monat',
    'userActivity.periodYear': 'Jahr',
    'userActivity.currentYear': 'Aktuelles Jahr',
    'userActivity.today': 'Heute',
    'userActivity.allWeeks': 'Alle Wochen',
    'userActivity.currentWeek': 'Aktuelle Woche',
    'userActivity.week': 'Woche',
    'userActivity.filterPeriod': 'Analysen-Filterzeitraum',
    'userActivity.filterSubtitle': 'Wählen Sie Jahr, Monat oder Woche, um Gesamtdaten aller Diagramme zu filtern',
    'userActivity.selectYear': 'Jahr',
    'userActivity.selectMonth': 'Monat',
    'userActivity.selectWeek': 'Woche',
    'userActivity.filterTitle': 'Aktivität filtern',
    'userActivity.searchPlaceholder': 'Name oder E-Mail suchen',
    'userActivity.typeToFilter': 'Zum Filtern eingeben...',
    'userActivity.categoryLabel': 'Kategorie',
    'userActivity.allCategories': 'Alle Kategorien',
    'userActivity.selectDate': 'Datum auswählen',
    'userActivity.clearFilters': 'Filter zurücksetzen',
    'userActivity.colInformation': 'Informationen',
    'userActivity.colCategory': 'Kategorie',
    'userActivity.colCity': 'Stadt',
    'userActivity.colTotalVisits': 'Gesamtbesuche',
    'userActivity.colUniqueVisitors': 'Eindeutige Besucher',
    'userActivity.colLastActivity': 'Letztes Aktivitätsdatum',
    'userActivity.colAction': 'Aktion',
    'userActivity.viewDetailsTooltip': 'Aktivitätsdetails anzeigen',
    'userActivity.noRecords': 'Keine Aktivitätsdatensätze gefunden',
    'userActivity.noRecordsSub': 'Versuchen Sie, Ihre Suchanfrage anzupassen oder die Filter zurückzusetzen.',
    'userActivity.modalTitle': 'Besucheraktivitätsdetails',
    'userActivity.modalSub': 'Liste der Benutzer und Besucher, die mit diesem Eintrag interagiert haben.',
    'userActivity.modalLogTitle': 'Besucher-Aktivitätsprotokoll',
    'userActivity.colVisitor': 'Besucher',
    'userActivity.colEmail': 'E-Mail',
    'userActivity.colVisitedDate': 'Besuchsdatum & -zeit',
    'userActivity.noVisitorLogs': 'Keine Besucheraktivitätsprotokolle für diesen Eintrag gefunden.',
    'userActivity.close': 'Schließen',
    'userActivity.guest': 'Gast',
    'userActivity.user': 'Benutzer',
    'userActivity.xlsSuccess': 'XLS-Bericht erfolgreich heruntergeladen.',
    'userActivity.xlsError': 'Fehler beim Herunterladen des XLS-Berichts.',
    'userActivity.detailError': 'Fehler beim Laden der Besucheraktivitätsdetails.',
    'userActivity.loadError': 'Fehler beim Laden der Benutzeraktivitätsdaten.',
  },
};
